webpackJsonp([1],{

/***/ 112:
/***/ (function(module, exports) {

module.exports = "<svg id=\"__1Dm1det__dd6d3b5d-736e-4112-a978-d559f0ef793b\" data-name=\"70f8052d-3d8c-41fb-92d4-1085a59c667f\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 35.39 3.6\"><title>donauhof-seperator</title><path d=\"M.35,1.9a3.73,3.73,0,0,0,2.7,1.2c3.5,0,2.3-2.6,5.8-2.6,2.9,0,3.1,2.6,5.8,2.6,3,0,2.6-2.6,5.7-2.6,2.8,0,3.3,2.6,5.8,2.6,3,0,2.8-2.6,5.8-2.6a4.37,4.37,0,0,1,3.1,1.4\" style=\"fill:none;stroke:#da9533;stroke-miterlimit:10\"></path></svg>"

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _gsScope = (typeof(module) !== "undefined" && module.exports && typeof(global) !== "undefined") ? global : this || window; //helps ensure compatibility with AMD/RequireJS and CommonJS/Node
(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push( function() {

	"use strict";

	var _doc = _gsScope.document,
		_getComputedStyle = _doc.defaultView ? _doc.defaultView.getComputedStyle : function() {},
		_numbersExp = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig,
		DrawSVGPlugin;

	function getDistance(x1, y1, x2, y2, scaleX, scaleY) {
		x2 = (parseFloat(x2) - parseFloat(x1)) * scaleX;
		y2 = (parseFloat(y2) - parseFloat(y1)) * scaleY;
		return Math.sqrt(x2 * x2 + y2 * y2);
	}

	function unwrap(element) {
		if (typeof(element) === "string" || !element.nodeType) {
			element = _gsScope.TweenLite.selector(element);
			if (element.length) {
				element = element[0];
			}
		}
		return element;
	}

	//accepts values like "100%" or "20% 80%" or "20 50" and parses it into an absolute start and end position on the line/stroke based on its length. Returns an an array with the start and end values, like [0, 243]
	function parse(value, length, defaultStart) {
		var i = value.indexOf(" "),
			s, e;
		if (i === -1) {
			s = defaultStart !== undefined ? defaultStart + "" : value;
			e = value;
		} else {
			s = value.substr(0, i);
			e = value.substr(i+1);
		}
		s = (s.indexOf("%") !== -1) ? (parseFloat(s) / 100) * length : parseFloat(s);
		e = (e.indexOf("%") !== -1) ? (parseFloat(e) / 100) * length : parseFloat(e);
		return (s > e) ? [e, s] : [s, e];
	}

	function getLength(element) {
		if (!element) {
			return 0;
		}
		element = unwrap(element);
		var type = element.tagName.toLowerCase(),
			scaleX = 1,
			scaleY = 1,
			length, bbox, points, prevPoint, i, rx, ry;
		if (element.getAttribute("vector-effect") === "non-scaling-stroke") { //non-scaling-stroke basically scales the shape and then strokes it at the screen-level (after transforms), thus we need to adjust the length accordingly.
			scaleY = element.getScreenCTM();
			scaleX = scaleY.a;
			scaleY = scaleY.d;
		}
		try { //IE bug: calling <path>.getTotalLength() locks the repaint area of the stroke to whatever its current dimensions are on that frame/tick. To work around that, we must call getBBox() to force IE to recalculate things.
			bbox = element.getBBox(); //solely for fixing bug in IE - we don't actually use the bbox.
		} catch (e) {
			//firefox has a bug that throws an error if the element isn't visible.
		}
		if ((!bbox || (!bbox.width && !bbox.height)) && (type === "rect" || type === "circle" || type === "ellipse")) { //if the element isn't visible, try to discern width/height using its attributes.
			bbox = {
				width: parseFloat( element.getAttribute( (type === "rect") ? "width" : (type === "circle") ? "r" : "rx")),
				height: parseFloat( element.getAttribute( (type === "rect") ? "height" : (type === "circle") ? "r" : "ry") )
			};
			if (type !== "rect") {
				bbox.width *= 2;
				bbox.height *= 2;
			}
		}
		if (type === "path") {
			prevPoint = element.style.strokeDasharray;
			element.style.strokeDasharray = "none";
			length = element.getTotalLength() || 0;
			if (scaleX !== scaleY) {
				console.log("Warning: <path> length cannot be measured accurately when vector-effect is non-scaling-stroke and the element isn't proportionally scaled.");
			}
			length *= (scaleX + scaleY) / 2;
			element.style.strokeDasharray = prevPoint;
		} else if (type === "rect") {
			length = bbox.width * 2 * scaleX + bbox.height * 2 * scaleY;
		} else if (type === "line") {
			length = getDistance(element.getAttribute("x1"), element.getAttribute("y1"), element.getAttribute("x2"), element.getAttribute("y2"), scaleX, scaleY);
		} else if (type === "polyline" || type === "polygon") {
			points = element.getAttribute("points").match(_numbersExp) || [];
			if (type === "polygon") {
				points.push(points[0], points[1]);
			}
			length = 0;
			for (i = 2; i < points.length; i+=2) {
				length += getDistance(points[i-2], points[i-1], points[i], points[i+1], scaleX, scaleY) || 0;
			}
		} else if (type === "circle" || type === "ellipse") {
			rx = (bbox.width / 2) * scaleX;
			ry = (bbox.height / 2) * scaleY;
			length = Math.PI * ( 3 * (rx + ry) - Math.sqrt((3 * rx + ry) * (rx + 3 * ry)) );
		}
		return length || 0;
	}

	function getPosition(element, length) {
		if (!element) {
			return [0, 0];
		}
		element = unwrap(element);
		length = length || (getLength(element) + 1);
		var cs = _getComputedStyle(element),
			dash = cs.strokeDasharray || "",
			offset = parseFloat(cs.strokeDashoffset),
			i = dash.indexOf(",");
		if (i < 0) {
			i = dash.indexOf(" ");
		}
		dash = (i < 0) ? length : parseFloat(dash.substr(0, i)) || 0.00001;
		if (dash > length) {
			dash = length;
		}
		return [Math.max(0, -offset), Math.max(0, dash - offset)];
	}

	DrawSVGPlugin = _gsScope._gsDefine.plugin({
		propName: "drawSVG",
		API: 2,
		version: "0.1.1",
		global: true,
		overwriteProps: ["drawSVG"],

		init: function(target, value, tween, index) {
			if (!target.getBBox) {
				return false;
			}
			var length = getLength(target) + 1,
				start, end, overage;
			this._style = target.style;
			if (typeof(value) === "function") {
				value = value(index, target);
			}
			if (value === true || value === "true") {
				value = "0 100%";
			} else if (!value) {
				value = "0 0";
			} else if ((value + "").indexOf(" ") === -1) {
				value = "0 " + value;
			}
			start = getPosition(target, length);
			end = parse(value, length, start[0]);
			this._length = length + 10;
			if (start[0] === 0 && end[0] === 0) {
				overage = Math.max(0.00001, end[1] - length); //allow people to go past the end, like values of 105% because for some paths, Firefox doesn't return an accurate getTotalLength(), so it could end up coming up short.
				this._dash = length + overage;
				this._offset = length - start[1] + overage;
				this._addTween(this, "_offset", this._offset, length - end[1] + overage, "drawSVG");
			} else {
				this._dash = (start[1] - start[0]) || 0.000001; //some browsers render artifacts if dash is 0, so we use a very small number in that case.
				this._offset = -start[0];
				this._addTween(this, "_dash", this._dash, (end[1] - end[0]) || 0.00001, "drawSVG");
				this._addTween(this, "_offset", this._offset, -end[0], "drawSVG");
			}
			return true;
		},

		//called each time the values should be updated, and the ratio gets passed as the only parameter (typically it's a value between 0 and 1, but it can exceed those when using an ease like Elastic.easeOut or Back.easeOut, etc.)
		set: function(ratio) {
			if (this._firstPT) {
				this._super.setRatio.call(this, ratio);
				this._style.strokeDashoffset = this._offset;
				if (ratio === 1 || ratio === 0) {
					this._style.strokeDasharray = (this._offset < 0.001 && this._length - this._dash <= 10) ? "none" : (this._offset === this._dash) ? "0px, 999999px" : this._dash + "px," + this._length + "px";
				} else {
					this._style.strokeDasharray = this._dash + "px," + this._length + "px";
				}
			}
		}

	});

	DrawSVGPlugin.getLength = getLength;
	DrawSVGPlugin.getPosition = getPosition;

}); if (_gsScope._gsDefine) { _gsScope._gsQueue.pop()(); }
//export to AMD/RequireJS and CommonJS/Node (precursor to full modular build system coming at a later date)
(function(name) {
	"use strict";
	var getGlobal = function() {
		return (_gsScope.GreenSockGlobals || _gsScope)[name];
	};
	if (true) { //AMD
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(393)], __WEBPACK_AMD_DEFINE_FACTORY__ = (getGlobal),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof(module) !== "undefined" && module.exports) { //node
		require("gsap/TweenLite");
		module.exports = getGlobal();
	}
}("DrawSVGPlugin"));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _gsScope="undefined"!=typeof module&&module.exports&&"undefined"!=typeof global?global:this||window;!function(a){"use strict";var b=a.GreenSockGlobals||a,c=function(a){var c,d=a.split("."),e=b;for(c=0;c<d.length;c++)e[d[c]]=e=e[d[c]]||{};return e},d=c("com.greensock.utils"),e=function(a){var b=a.nodeType,c="";if(1===b||9===b||11===b){if("string"==typeof a.textContent)return a.textContent;for(a=a.firstChild;a;a=a.nextSibling)c+=e(a)}else if(3===b||4===b)return a.nodeValue;return c},f=document,g=f.defaultView?f.defaultView.getComputedStyle:function(){},h=/([A-Z])/g,i=function(a,b,c,d){var e;return(c=c||g(a,null))?(a=c.getPropertyValue(b.replace(h,"-$1").toLowerCase()),e=a||c.length?a:c[b]):a.currentStyle&&(c=a.currentStyle,e=c[b]),d?e:parseInt(e,10)||0},j=function(a){return a.length&&a[0]&&(a[0].nodeType&&a[0].style&&!a.nodeType||a[0].length&&a[0][0])?!0:!1},k=function(a){var b,c,d,e=[],f=a.length;for(b=0;f>b;b++)if(c=a[b],j(c))for(d=c.length,d=0;d<c.length;d++)e.push(c[d]);else e.push(c);return e},l=/(?:\r|\n|\t\t)/g,m=/(?:\s\s+)/g,n=55296,o=56319,p=56320,q=127462,r=127487,s=127995,t=127999,u=function(a){return(a.charCodeAt(0)-n<<10)+(a.charCodeAt(1)-p)+65536},v=f.all&&!f.addEventListener,w=" style='position:relative;display:inline-block;"+(v?"*display:inline;*zoom:1;'":"'"),x=function(a,b){a=a||"";var c=-1!==a.indexOf("++"),d=1;return c&&(a=a.split("++").join("")),function(){return"<"+b+w+(a?" class='"+a+(c?d++:"")+"'>":">")}},y=d.SplitText=b.SplitText=function(a,b){if("string"==typeof a&&(a=y.selector(a)),!a)throw"cannot split a null element.";this.elements=j(a)?k(a):[a],this.chars=[],this.words=[],this.lines=[],this._originals=[],this.vars=b||{},this.split(b)},z=function(a,b,c){var d=a.nodeType;if(1===d||9===d||11===d)for(a=a.firstChild;a;a=a.nextSibling)z(a,b,c);else(3===d||4===d)&&(a.nodeValue=a.nodeValue.split(b).join(c))},A=function(a,b){for(var c=b.length;--c>-1;)a.push(b[c])},B=function(a){var b,c=[],d=a.length;for(b=0;b!==d;c.push(a[b++]));return c},C=function(a,b,c){for(var d;a&&a!==b;){if(d=a._next||a.nextSibling)return d.textContent.charAt(0)===c;a=a.parentNode||a._parent}return!1},D=function(a){var b,c,d=B(a.childNodes),e=d.length;for(b=0;e>b;b++)c=d[b],c._isSplit?D(c):(b&&3===c.previousSibling.nodeType?c.previousSibling.nodeValue+=3===c.nodeType?c.nodeValue:c.firstChild.nodeValue:3!==c.nodeType&&a.insertBefore(c.firstChild,c),a.removeChild(c))},E=function(a,b,c,d,e,h,j){var k,l,m,n,o,p,q,r,s,t,u,v,w=g(a),x=i(a,"paddingLeft",w),y=-999,B=i(a,"borderBottomWidth",w)+i(a,"borderTopWidth",w),E=i(a,"borderLeftWidth",w)+i(a,"borderRightWidth",w),F=i(a,"paddingTop",w)+i(a,"paddingBottom",w),G=i(a,"paddingLeft",w)+i(a,"paddingRight",w),H=.2*i(a,"fontSize"),I=i(a,"textAlign",w,!0),J=[],K=[],L=[],M=b.wordDelimiter||" ",N=b.span?"span":"div",O=b.type||b.split||"chars,words,lines",P=e&&-1!==O.indexOf("lines")?[]:null,Q=-1!==O.indexOf("words"),R=-1!==O.indexOf("chars"),S="absolute"===b.position||b.absolute===!0,T=b.linesClass,U=-1!==(T||"").indexOf("++"),V=[];for(P&&1===a.children.length&&a.children[0]._isSplit&&(a=a.children[0]),U&&(T=T.split("++").join("")),l=a.getElementsByTagName("*"),m=l.length,o=[],k=0;m>k;k++)o[k]=l[k];if(P||S)for(k=0;m>k;k++)n=o[k],p=n.parentNode===a,(p||S||R&&!Q)&&(v=n.offsetTop,P&&p&&Math.abs(v-y)>H&&"BR"!==n.nodeName&&(q=[],P.push(q),y=v),S&&(n._x=n.offsetLeft,n._y=v,n._w=n.offsetWidth,n._h=n.offsetHeight),P&&((n._isSplit&&p||!R&&p||Q&&p||!Q&&n.parentNode.parentNode===a&&!n.parentNode._isSplit)&&(q.push(n),n._x-=x,C(n,a,M)&&(n._wordEnd=!0)),"BR"===n.nodeName&&n.nextSibling&&"BR"===n.nextSibling.nodeName&&P.push([])));for(k=0;m>k;k++)n=o[k],p=n.parentNode===a,"BR"!==n.nodeName?(S&&(s=n.style,Q||p||(n._x+=n.parentNode._x,n._y+=n.parentNode._y),s.left=n._x+"px",s.top=n._y+"px",s.position="absolute",s.display="block",s.width=n._w+1+"px",s.height=n._h+"px"),!Q&&R?n._isSplit?(n._next=n.nextSibling,n.parentNode.appendChild(n)):n.parentNode._isSplit?(n._parent=n.parentNode,!n.previousSibling&&n.firstChild&&(n.firstChild._isFirst=!0),n.nextSibling&&" "===n.nextSibling.textContent&&!n.nextSibling.nextSibling&&V.push(n.nextSibling),n._next=n.nextSibling&&n.nextSibling._isFirst?null:n.nextSibling,n.parentNode.removeChild(n),o.splice(k--,1),m--):p||(v=!n.nextSibling&&C(n.parentNode,a,M),n.parentNode._parent&&n.parentNode._parent.appendChild(n),v&&n.parentNode.appendChild(f.createTextNode(" ")),b.span&&(n.style.display="inline"),J.push(n)):n.parentNode._isSplit&&!n._isSplit&&""!==n.innerHTML?K.push(n):R&&!n._isSplit&&(b.span&&(n.style.display="inline"),J.push(n))):P||S?(n.parentNode&&n.parentNode.removeChild(n),o.splice(k--,1),m--):Q||a.appendChild(n);for(k=V.length;--k>-1;)V[k].parentNode.removeChild(V[k]);if(P){for(S&&(t=f.createElement(N),a.appendChild(t),u=t.offsetWidth+"px",v=t.offsetParent===a?0:a.offsetLeft,a.removeChild(t)),s=a.style.cssText,a.style.cssText="display:none;";a.firstChild;)a.removeChild(a.firstChild);for(r=" "===M&&(!S||!Q&&!R),k=0;k<P.length;k++){for(q=P[k],t=f.createElement(N),t.style.cssText="display:block;text-align:"+I+";position:"+(S?"absolute;":"relative;"),T&&(t.className=T+(U?k+1:"")),L.push(t),m=q.length,l=0;m>l;l++)"BR"!==q[l].nodeName&&(n=q[l],t.appendChild(n),r&&n._wordEnd&&t.appendChild(f.createTextNode(" ")),S&&(0===l&&(t.style.top=n._y+"px",t.style.left=x+v+"px"),n.style.top="0px",v&&(n.style.left=n._x-v+"px")));0===m?t.innerHTML="&nbsp;":Q||R||(D(t),z(t,String.fromCharCode(160)," ")),S&&(t.style.width=u,t.style.height=n._h+"px"),a.appendChild(t)}a.style.cssText=s}S&&(j>a.clientHeight&&(a.style.height=j-F+"px",a.clientHeight<j&&(a.style.height=j+B+"px")),h>a.clientWidth&&(a.style.width=h-G+"px",a.clientWidth<h&&(a.style.width=h+E+"px"))),A(c,J),A(d,K),A(e,L)},F=function(a,b,c,d){var g,h,i,j,k,p,v,w,x,y=b.span?"span":"div",A=b.type||b.split||"chars,words,lines",B=(-1!==A.indexOf("words"),-1!==A.indexOf("chars")),C="absolute"===b.position||b.absolute===!0,D=b.wordDelimiter||" ",E=" "!==D?"":C?"&#173; ":" ",F=b.span?"</span>":"</div>",G=!0,H=f.createElement("div"),I=a.parentNode;for(I.insertBefore(H,a),H.textContent=a.nodeValue,I.removeChild(a),a=H,g=e(a),v=-1!==g.indexOf("<"),b.reduceWhiteSpace!==!1&&(g=g.replace(m," ").replace(l,"")),v&&(g=g.split("<").join("{{LT}}")),k=g.length,h=(" "===g.charAt(0)?E:"")+c(),i=0;k>i;i++)if(p=g.charAt(i),p===D&&g.charAt(i-1)!==D&&i){for(h+=G?F:"",G=!1;g.charAt(i+1)===D;)h+=E,i++;i===k-1?h+=E:")"!==g.charAt(i+1)&&(h+=E+c(),G=!0)}else"{"===p&&"{{LT}}"===g.substr(i,6)?(h+=B?d()+"{{LT}}</"+y+">":"{{LT}}",i+=5):p.charCodeAt(0)>=n&&p.charCodeAt(0)<=o||g.charCodeAt(i+1)>=65024&&g.charCodeAt(i+1)<=65039?(w=u(g.substr(i,2)),x=u(g.substr(i+2,2)),j=w>=q&&r>=w&&x>=q&&r>=x||x>=s&&t>=x?4:2,h+=B&&" "!==p?d()+g.substr(i,j)+"</"+y+">":g.substr(i,j),i+=j-1):h+=B&&" "!==p?d()+p+"</"+y+">":p;a.outerHTML=h+(G?F:""),v&&z(I,"{{LT}}","<")},G=function(a,b,c,d){var e,f,g=B(a.childNodes),h=g.length,j="absolute"===b.position||b.absolute===!0;if(3!==a.nodeType||h>1){for(b.absolute=!1,e=0;h>e;e++)f=g[e],(3!==f.nodeType||/\S+/.test(f.nodeValue))&&(j&&3!==f.nodeType&&"inline"===i(f,"display",null,!0)&&(f.style.display="inline-block",f.style.position="relative"),f._isSplit=!0,G(f,b,c,d));return b.absolute=j,void(a._isSplit=!0)}F(a,b,c,d)},H=y.prototype;H.split=function(a){this.isSplit&&this.revert(),this.vars=a=a||this.vars,this._originals.length=this.chars.length=this.words.length=this.lines.length=0;for(var b,c,d,e=this.elements.length,f=a.span?"span":"div",g=("absolute"===a.position||a.absolute===!0,x(a.wordsClass,f)),h=x(a.charsClass,f);--e>-1;)d=this.elements[e],this._originals[e]=d.innerHTML,b=d.clientHeight,c=d.clientWidth,G(d,a,g,h),E(d,a,this.chars,this.words,this.lines,c,b);return this.chars.reverse(),this.words.reverse(),this.lines.reverse(),this.isSplit=!0,this},H.revert=function(){if(!this._originals)throw"revert() call wasn't scoped properly.";for(var a=this._originals.length;--a>-1;)this.elements[a].innerHTML=this._originals[a];return this.chars=[],this.words=[],this.lines=[],this.isSplit=!1,this},y.selector=a.$||a.jQuery||function(b){var c=a.$||a.jQuery;return c?(y.selector=c,c(b)):"undefined"==typeof document?b:document.querySelectorAll?document.querySelectorAll(b):document.getElementById("#"===b.charAt(0)?b.substr(1):b)},y.version="0.5.6"}(_gsScope),function(a){"use strict";var b=function(){return(_gsScope.GreenSockGlobals||_gsScope)[a]}; true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (b),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!=typeof module&&module.exports&&(module.exports=b())}("SplitText");
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

module.exports = {srcSet:__webpack_require__.p + "assets/img/donauhof-about-image.e181e5df8f03b60a9f0ecd0b60560f33-320.jpg 320w"+","+__webpack_require__.p + "assets/img/donauhof-about-image.c553335d32f40175a1e1b181334a64dc-640.jpg 640w"+","+__webpack_require__.p + "assets/img/donauhof-about-image.9dbc0425905bb1240c2b823110e7672f-1200.jpg 1200w",images:[{path:__webpack_require__.p + "assets/img/donauhof-about-image.e181e5df8f03b60a9f0ecd0b60560f33-320.jpg",width:320,height:400},{path:__webpack_require__.p + "assets/img/donauhof-about-image.c553335d32f40175a1e1b181334a64dc-640.jpg",width:640,height:800},{path:__webpack_require__.p + "assets/img/donauhof-about-image.9dbc0425905bb1240c2b823110e7672f-1200.jpg",width:1200,height:1500}],src:__webpack_require__.p + "assets/img/donauhof-about-image.e181e5df8f03b60a9f0ecd0b60560f33-320.jpg",toString:function(){return __webpack_require__.p + "assets/img/donauhof-about-image.e181e5df8f03b60a9f0ecd0b60560f33-320.jpg"},placeholder: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSgBBwcHCggKEwoKEygaFhooKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKP/AABEIAD8AMgMBEQACEQEDEQH/xAGiAAABBQEBAQEBAQAAAAAAAAAAAQIDBAUGBwgJCgsQAAIBAwMCBAMFBQQEAAABfQECAwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5+gEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoLEQACAQIEBAMEBwUEBAABAncAAQIDEQQFITEGEkFRB2FxEyIygQgUQpGhscEJIzNS8BVictEKFiQ04SXxFxgZGiYnKCkqNTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqCg4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2dri4+Tl5ufo6ery8/T19vf4+fr/2gAMAwEAAhEDEQA/APngWhK5xWHMa2JntXSEnBAx2oTuDRlyQBVDg7om6H0q1LoS0RbR2qrisWbZQ8ZH8a/qKlspELjFNCY3cvcc0yTtLCyL4yM5rlkzpijXm0vNkDsyGQHP4VKkNxPOogVKjgo3X0PP6GulmAksJ81ljB4HQ1SegmRKGVs8gj3piELA5+boaAGfL/eNMR7FpWmyoFLxHHTNcUk0dcbM6qy0tJ9LjDL/AMsh/Ks2aLY8Mjtt5RlIY4GSBg/f7jpXVc5bHU2vhc6lcXxjuLe38iF5j5zhQwA+6PUn0oi9ByWpwl8Cs7DsDWyMWVDVCE5oA+hbZitkTkcEfzrlqLQ6ab1Oj0Y5sIR6oB+lYNam62PMtV8EXdhh7e8SeMdQ4wfvZ681op90ZOHmZXiF8PJ5ZGM4ODWkDOe5w971Y1ujFlVRlaYgwPWgD3BblrfRyX2+YoXcOcZyKxqL3Tam9SxpPiN1iRDEu0RjDBu/0rmbOhHLyarJP8RYN8rNb+YmImYlB8gzx0re16Vznk/3pY+IAtY0Q2lrFG7v83lIFzx3xWdFvqXUt0PNrhHUOXTA6YPvXWjnZnkjHTAz0piGfjTA9b1W5P8AZsoB64/nUTWhUHqY1reGONRk9MVzOOp0KWhmR3B/4S2CTp86fyFbRX7uxhJ+/c2vFUsc9qzSltyDcm09/f25qaMdQqSOFuGLxKQSSDit7EXKhjbuKYCeXQB6FqM4GnS5OTgfzpTWgoPUwFuGwADn6VjymvMQFZRfpcptO0g4Oe1aLaxD3uWp5JrhW+0yEhv4RwBTStsJ6lNwiDC7cegp3FYqyuozxT5gsQeYPT9KfMFjauLkOGWaZiMfcVcDNDS6kK/Qj86NQfLjIwQMk5paFajXuicgnvj0pDITKWzxzmgZBLKMUAVnck4oAhJOTzQM/wD/2Q==",width:320,height:400};

/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

module.exports = {srcSet:__webpack_require__.p + "assets/img/donauhof-ballsaal-image.d1f0512c783194e095708cb454266cef-320.jpg 320w"+","+__webpack_require__.p + "assets/img/donauhof-ballsaal-image.4e4868e67d3cc8152af78a3c6a111849-640.jpg 640w"+","+__webpack_require__.p + "assets/img/donauhof-ballsaal-image.dedff5214801371dca191206359495d3-960.jpg 960w",images:[{path:__webpack_require__.p + "assets/img/donauhof-ballsaal-image.d1f0512c783194e095708cb454266cef-320.jpg",width:320,height:400},{path:__webpack_require__.p + "assets/img/donauhof-ballsaal-image.4e4868e67d3cc8152af78a3c6a111849-640.jpg",width:640,height:800},{path:__webpack_require__.p + "assets/img/donauhof-ballsaal-image.dedff5214801371dca191206359495d3-960.jpg",width:960,height:1200}],src:__webpack_require__.p + "assets/img/donauhof-ballsaal-image.d1f0512c783194e095708cb454266cef-320.jpg",toString:function(){return __webpack_require__.p + "assets/img/donauhof-ballsaal-image.d1f0512c783194e095708cb454266cef-320.jpg"},placeholder: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSgBBwcHCggKEwoKEygaFhooKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKP/AABEIAD8AMgMBEQACEQEDEQH/xAGiAAABBQEBAQEBAQAAAAAAAAAAAQIDBAUGBwgJCgsQAAIBAwMCBAMFBQQEAAABfQECAwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5+gEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoLEQACAQIEBAMEBwUEBAABAncAAQIDEQQFITEGEkFRB2FxEyIygQgUQpGhscEJIzNS8BVictEKFiQ04SXxFxgZGiYnKCkqNTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqCg4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2dri4+Tl5ufo6ery8/T19vf4+fr/2gAMAwEAAhEDEQA/APmUFe6n86k0HZT+63/fX/1qQDg0ePuP/wB9/wD1qAAtHnhH/wC+v/rUAGV/ut/31/8AWoGGR6frQAZoAgzTJFoGOFABxmkAtACZoGGaAGCqJN3wd4avvFWtxabpwUOw3PI3Coo6k0gbsfS2g/D/AEDwpYSp/Y1pe3Itt0k90RLIWw3K5GF6DpV2SIu2aMfhTRNbgntr7RNNlBiDqVGHGXlH3goI6dj2FToM8I+L/wANZfBV+Z7I+ZpchGBv3tCTn5ScDI44P+TN9bF+Z5qaYDcUAIKYj339nO0ig0zUb+WxjuN7Mu5mwRtUHA/OiO5Mj2XxTOqrfrPo4jzbdiOR83pVMlGZ4cuoo4LoppRB8jrx82Hl9vapRQfFO0h1Lwjra31gqXAtQyfdAH3iD+Y/SlJdRp9D4zcYYj04pFCUwGCmI92/Zr12whm1HSdQErSSKZIVSQruGMMPvDnp+FEXZkyR9C+KIdN+w3xaO9y9sT/x8E54bj79USc3ZxIbOVI4bqMiIqQ0xAYebLx97nvUspHI/GTVE0nw9qEVxHMjSxrGu6ckuxDYGNx45/SocnexairXPlhjlqoQZoGMpiLOn3txp95FdWczw3ETBkdDgg0Ae5aT8cbW/snh8UWNwtw0PlmW0YsjHBGShYY69jRcmxoyfGPwzYWUhs4tRvLlkKpGcooO+QjLFsj7w6A96Q7Hjfj3xlqPjLWHvtQIjQcRQIxKxj8SST70W6jOYpgGaAEoAWgAIoADQAUAFABQA8GPuH/Aj/CgBwMGeUl/77H+FLUB4e3xzHN/38H/AMTRqAPJbMxJhkB9FkAH/oNGoDMwc/u5P++x/hRqAhMXZH/77H+FGoxP3f8Adb/vr/61GoWP/9k=",width:320,height:400};

/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

module.exports = {srcSet:__webpack_require__.p + "assets/img/donauhof-cafe-image.6a236a7a9aaf8fe774b071f34383c855-320.jpg 320w"+","+__webpack_require__.p + "assets/img/donauhof-cafe-image.e8418ff4c7157da14bd0dc9fb00e708e-640.jpg 640w"+","+__webpack_require__.p + "assets/img/donauhof-cafe-image.ca09b1739dd136fb3587fe8d2c1ba3e1-960.jpg 960w",images:[{path:__webpack_require__.p + "assets/img/donauhof-cafe-image.6a236a7a9aaf8fe774b071f34383c855-320.jpg",width:320,height:400},{path:__webpack_require__.p + "assets/img/donauhof-cafe-image.e8418ff4c7157da14bd0dc9fb00e708e-640.jpg",width:640,height:800},{path:__webpack_require__.p + "assets/img/donauhof-cafe-image.ca09b1739dd136fb3587fe8d2c1ba3e1-960.jpg",width:960,height:1200}],src:__webpack_require__.p + "assets/img/donauhof-cafe-image.6a236a7a9aaf8fe774b071f34383c855-320.jpg",toString:function(){return __webpack_require__.p + "assets/img/donauhof-cafe-image.6a236a7a9aaf8fe774b071f34383c855-320.jpg"},placeholder: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSgBBwcHCggKEwoKEygaFhooKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKP/AABEIAD8AMgMBEQACEQEDEQH/xAGiAAABBQEBAQEBAQAAAAAAAAAAAQIDBAUGBwgJCgsQAAIBAwMCBAMFBQQEAAABfQECAwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5+gEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoLEQACAQIEBAMEBwUEBAABAncAAQIDEQQFITEGEkFRB2FxEyIygQgUQpGhscEJIzNS8BVictEKFiQ04SXxFxgZGiYnKCkqNTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqCg4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2dri4+Tl5ufo6ery8/T19vf4+fr/2gAMAwEAAhEDEQA/APnFBWRoTbf5UgJI09aqwrkjoSPlFKwJjcEDkGkMgOSxFMBNtAhqnmkMtxjI7c00Jk4QHOA3Bx2p3FYcIsjkMaVx2G3CBQBg9M0AVRgseBmgBv8AnpQAW8e5wuKQzShtiSv1FOIpM0orIv8AacIRtlIpWC42S2kjQgrxmkMz79GV+Rj5R/M0wKkcTMNwH40IBhEn91v1ouBHb3PkEO0Dk4zkEdKpIlnS6XKlyqsIWQHaQWH3hnrWiRmzd0yAsl8eo+0sP5VC6lE0tssm4D+/g0co7mHr1rtutqDdhRwMf1oUQ5jD3ShgskOMkjGRx7UWC4GZAcblpDuU7OKKWQLIoINUkJs7jS7OFYlEaBcAD8BWyijJyPVvhh4Jtdf07WZprkxtFM5RE5JPB59ulcierOi2iMPxX4ZPh7WJ7T52VnMiMe4Y5H+RWsdURJWZx2s2udTlUpkBFPX6/wCFaJGbZiTW8Um0shyzYHzdxScR3HC1jAACDA46UWHc5OwmAnXJHWoQ2eg6c6CFSZFGPeui5j1O/wDhzrNlaWOvSTXN0jlpfL8lwE54G7J5B56fhXD1Z1rYteOPEVnfX1vN58iN5ahkuF24IA+7g/dPX8a1hoRPU4bU7q1n1CWWOSJvlUZDfWt4tGLRh3CQeaJC0ZIJ4zQ7AgFxb92GaLoLFC08O28KhnA+rUvZ2DnuacUEFvjYi/lQ4DUi5DfvEfkO0elQ6ZamLqZkK7nYtlQwJByalRKcjBlYt3z7VfKRcqyIrZ4FPlFch2D+7T5QudZM3G1V5rexz3KrAlDntSaKTKrSrvwKlodySe/eS08mZnYL9056VPKWpGVI54XBOenNArjGZlOOo9M0AOBb0/WiwXP/2Q==",width:320,height:400};

/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

module.exports = {srcSet:__webpack_require__.p + "assets/img/donauhof-co-working-image.38c18b53a19333d8c222032c1045e1bc-320.jpg 320w"+","+__webpack_require__.p + "assets/img/donauhof-co-working-image.a931cf394157948b4deb7e2c892b2385-640.jpg 640w"+","+__webpack_require__.p + "assets/img/donauhof-co-working-image.84c5376659c142bd632268dec357abaf-1280.jpg 1280w"+","+__webpack_require__.p + "assets/img/donauhof-co-working-image.88f70e49eb594d1a3726a7e6516b4231-1440.jpg 1440w",images:[{path:__webpack_require__.p + "assets/img/donauhof-co-working-image.38c18b53a19333d8c222032c1045e1bc-320.jpg",width:320,height:400},{path:__webpack_require__.p + "assets/img/donauhof-co-working-image.a931cf394157948b4deb7e2c892b2385-640.jpg",width:640,height:800},{path:__webpack_require__.p + "assets/img/donauhof-co-working-image.84c5376659c142bd632268dec357abaf-1280.jpg",width:1280,height:1600},{path:__webpack_require__.p + "assets/img/donauhof-co-working-image.88f70e49eb594d1a3726a7e6516b4231-1440.jpg",width:1440,height:1800}],src:__webpack_require__.p + "assets/img/donauhof-co-working-image.38c18b53a19333d8c222032c1045e1bc-320.jpg",toString:function(){return __webpack_require__.p + "assets/img/donauhof-co-working-image.38c18b53a19333d8c222032c1045e1bc-320.jpg"},placeholder: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSgBBwcHCggKEwoKEygaFhooKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKP/AABEIAD8AMgMBEQACEQEDEQH/xAGiAAABBQEBAQEBAQAAAAAAAAAAAQIDBAUGBwgJCgsQAAIBAwMCBAMFBQQEAAABfQECAwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5+gEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoLEQACAQIEBAMEBwUEBAABAncAAQIDEQQFITEGEkFRB2FxEyIygQgUQpGhscEJIzNS8BVictEKFiQ04SXxFxgZGiYnKCkqNTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqCg4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2dri4+Tl5ufo6ery8/T19vf4+fr/2gAMAwEAAhEDEQA/APcPGkySaHLj+8v86Knwjhuc34MiE+qlCcfuz/MVjFXZpJ2RU1e38vxBdqeSH/pUtWZSd0TDAWmFyvMaQ0VX61LGREc0Adx40j8vR5f95f5101NjCG5h+B2cazlMZEfQ9/mWs6e5U9hNX/e+KLoEY3SDj8BRJXkOLtEuSaftXIp8guczLmEoahqxaZRk61DKI80Ad748/wCQNL/vr/Ouqp8Jzw3OY8EBm1k7G2sE4/76Ws6e5c9huquR4oudx5Egz+VD+IF8J0BkzEOc1qZmbcAM3IqWrlJ2Ma7jwxxWMomiZUwfSosO53njt86NL/vL/Ouqp8JhDc5PwZeR22tKZWCh12gn13A/0rOnuaT2K+v3sMPiW7eaVEQOCWY4A4FD+MSfumxb6jaXKhbe5ikb0Vga2VjO4kjGk0MoznJ9alopMq4HpUWKudb43lRtDnbcMAqf1rWp8JnB6nkc91fNAby2gaO0jcYuJTsRjnAAJxnmuVKW6NXJLQ5nVtXn1m9MTzCMzsqu6jcM4A4z24pKbciWtLGlY2+paVIDDqMRUnkFOcn8a31WzJUbHQL4g1CJQoQSju22hyaK5UQy+ItQPPlAfValzZXKiL+373/Y/wC+annYcqOo8c6qW8D6k6t8wiz+oroqO8TJKzOM+LN8y+CIJUlfiWM7d3HyoxGB2rOpsiY7nns026RPLY5kwwI9OtcjOiKudz4cmkkVftJYjHG/k1vDzHJnTvEpj4I9q0aIuU7hFPCgBsZ9M1LQyqbbnkc/WlYZneItaiuvCmoWtvMks8sW2ONGyWORQp3VhOJS8YwT694ctdPtVbzDIplZlKhF2nPJ6/h61UrtaGcY66lPSvDi2EEInkaaRF2hiOgHQVKp9WaKXRHUWckcEaqi4IGTx2rVKwrltpAoHzlfTnrSYJFaa5fsB15I5qWx2Kr3kO45d859KnQZQ0nT4EhUqoBzjOOaUIjkzf2BIdxGMcYrdIzZm3buSFB49PSiQIdG0jRsyLzyNucDoaV7oLWZIvmPbQl8ZOdxPOTSKITOGiLLjA+7gdaljKhuoASDuyOvH/1qWgan/9k=",width:320,height:400};

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

module.exports = {srcSet:__webpack_require__.p + "assets/img/donauhof-home-image.7152df0125e62826ce72fc5010b9f850-320.jpg 320w"+","+__webpack_require__.p + "assets/img/donauhof-home-image.9131c3e077b69d268e0023a919ca4185-640.jpg 640w"+","+__webpack_require__.p + "assets/img/donauhof-home-image.df653d92d7ea29dbc58ee738c22cc548-800.jpg 800w",images:[{path:__webpack_require__.p + "assets/img/donauhof-home-image.7152df0125e62826ce72fc5010b9f850-320.jpg",width:320,height:400},{path:__webpack_require__.p + "assets/img/donauhof-home-image.9131c3e077b69d268e0023a919ca4185-640.jpg",width:640,height:800},{path:__webpack_require__.p + "assets/img/donauhof-home-image.df653d92d7ea29dbc58ee738c22cc548-800.jpg",width:800,height:1000}],src:__webpack_require__.p + "assets/img/donauhof-home-image.7152df0125e62826ce72fc5010b9f850-320.jpg",toString:function(){return __webpack_require__.p + "assets/img/donauhof-home-image.7152df0125e62826ce72fc5010b9f850-320.jpg"},placeholder: "data:image/jpeg;base64,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",width:320,height:400};

/***/ }),

/***/ 175:
/***/ (function(module, exports) {

module.exports = "<svg id=\"__1Dm1det__9852a320-359c-4efa-ac58-e8ee2f46572a\" data-name=\"Contact\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\"><title>donauhof</title><path d=\"M32.83,20.13A14.83,14.83,0,1,1,18,5.34,14.81,14.81,0,0,1,32.83,20.13ZM18,31.31v3.63M29.17,20.13h3.63M18,9V5.33M3.19,20.13H6.83M18,1a1.85,1.85,0,1,0,1.85,1.85A1.85,1.85,0,0,0,18,1Zm0,18.51a.61.61,0,1,0,.61.61A.61.61,0,0,0,18,19.53Zm-1.13-.58-4.92,1.13,3.56.82ZM18,14l-1.13,4.92,2-1.34Zm0,12.11,1.13-4.92-2,1.33Zm1.13-4.92,4.92-1.13-3.58-.82ZM24.05,14l-7.18,4.92-5,7.21,7.29-4.95ZM9.24,11.38,7.53,9.66M9.24,28.89,7.53,30.6m19.23-1.71,1.71,1.71M26.76,11.38l1.71-1.71\" style=\"fill:none;stroke:#da9533;stroke-miterlimit:10\"></path></svg>"

/***/ }),

/***/ 176:
/***/ (function(module, exports) {

module.exports = "<svg id=\"__1Dm1det__96045226-6cb8-4f76-abca-ca0268658dd4\" data-name=\"Home\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\"><title>donauhof</title><path d=\"M34,29.5H2v-18H34Zm0-23H2V9H34ZM35.5,9H.5v2.5h35ZM2,20.49H34m-8,9h4v-6H26ZM6,23v4m4-4v4m4-4v4m4-4v4m4-4v4M6,14v4m4-4v4m4-4v4m4-4v4m4-4v4m4-4v4m4-4v4\" style=\"fill:none;stroke:#da9533;stroke-miterlimit:10\"></path></svg>"

/***/ }),

/***/ 177:
/***/ (function(module, exports) {

module.exports = "<svg id=\"__1Dm1det__231742ad-56b8-4594-b2a2-74c69f0f9bf9\" data-name=\"c0c1ba33-0cac-4b22-8109-af66d11e786e\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 75 75\"><defs><style>.__1Dm1det__e0afb91c-eb8f-497c-b382-8ce9daefffa1{fill:none;stroke:#333;stroke-linejoin:round;stroke-width:2px;}</style></defs><title>donauhof-logo</title><path class=\"__1Dm1det__e0afb91c-eb8f-497c-b382-8ce9daefffa1\" d=\"M1.8,29.2a6.44,6.44,0,0,0,9,.6l.6-.6a7.29,7.29,0,0,1,10.3-.8,3,3,0,0,1,.8.8,6.44,6.44,0,0,0,9,.6l.6-.6a7.29,7.29,0,0,1,10.3-.8,3,3,0,0,1,.8.8,6.44,6.44,0,0,0,9,.6l.6-.6a7.29,7.29,0,0,1,10.3-.8,3,3,0,0,1,.8.8,6.44,6.44,0,0,0,9,.6l.6-.6\"></path><path class=\"__1Dm1det__e0afb91c-eb8f-497c-b382-8ce9daefffa1\" d=\"M73.2,44.9a6.44,6.44,0,0,1-9,.6l-.6-.6a7.29,7.29,0,0,0-10.3-.8,3,3,0,0,0-.8.8,6.44,6.44,0,0,1-9,.6l-.6-.6a7.38,7.38,0,0,0-10.3-.8,6,6,0,0,0-.8.8,6.44,6.44,0,0,1-9,.6l-.6-.6a7.29,7.29,0,0,0-10.3-.8,3,3,0,0,0-.8.8,6.44,6.44,0,0,1-9,.6l-.6-.6\"></path><path class=\"__1Dm1det__e0afb91c-eb8f-497c-b382-8ce9daefffa1\" d=\"M1,37.1l.6.6a6.5,6.5,0,0,0,9.2-.6,6,6,0,0,1,.8-.8,7.45,7.45,0,0,1,10.5.8l.6.6a6.5,6.5,0,0,0,9.2-.6,6,6,0,0,1,.8-.8,7.45,7.45,0,0,1,10.5.8l.6.6a6.5,6.5,0,0,0,9.2-.6,6,6,0,0,1,.8-.8,7.45,7.45,0,0,1,10.5.8l.6.6a6.5,6.5,0,0,0,9.2-.6\"></path><circle class=\"__1Dm1det__e0afb91c-eb8f-497c-b382-8ce9daefffa1\" cx=\"37.5\" cy=\"37.5\" r=\"36.5\"></circle></svg>"

/***/ }),

/***/ 281:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(387)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(313),
  /* template */
  __webpack_require__(430),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(386)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(429),
  /* scopeId */
  "data-v-5f6b50c2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(384)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(427),
  /* scopeId */
  "data-v-586419d6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(392)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(435),
  /* scopeId */
  "data-v-f5d784e4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(379)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(421),
  /* scopeId */
  "data-v-1ffb9b38",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(378)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(420),
  /* scopeId */
  "data-v-143a126b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(390)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(433),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 312:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_data_view__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_data_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_data_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_int8_array__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_int8_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_int8_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_array__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_uint8_clamped_array__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_uint8_clamped_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_uint8_clamped_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_int16_array__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_int16_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_int16_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_uint16_array__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_uint16_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_uint16_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_int32_array__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_int32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_int32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_uint32_array__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_uint32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_uint32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float32_array__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_typed_float64_array__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_typed_float64_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_typed_float64_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_map__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_set__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_map__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_weak_set__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_weak_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_weak_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_apply__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_apply___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_apply__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_construct__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_construct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_construct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_define_property__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_delete_property__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_delete_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_delete_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_own_property_descriptor__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_get_prototype_of__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_has__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_is_extensible__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_is_extensible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_is_extensible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_own_keys__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_own_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_own_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_prevent_extensions__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_prevent_extensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_prevent_extensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_reflect_set_prototype_of__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_reflect_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_reflect_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_promise__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_symbol__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_freeze__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_seal__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_seal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_seal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_object_prevent_extensions__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_object_prevent_extensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_object_prevent_extensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_object_is_frozen__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_object_is_frozen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_object_is_frozen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_object_is_sealed__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_object_is_sealed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_object_is_sealed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_object_is_extensible__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_object_is_extensible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_object_is_extensible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_object_get_own_property_descriptor__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_object_get_prototype_of__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_object_keys__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_object_get_own_property_names__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_object_assign__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_object_is__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_object_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_object_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_object_set_prototype_of__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_function_name__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_function_name___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_function_name__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_string_raw__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_string_raw___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_string_raw__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_string_from_code_point__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_string_from_code_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_string_from_code_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_string_code_point_at__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_string_code_point_at___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_string_code_point_at__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_string_repeat__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_string_repeat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_string_repeat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_string_starts_with__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_string_starts_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_string_starts_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_string_ends_with__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_string_ends_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_string_ends_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_string_includes__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_string_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_string_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_regexp_flags__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_regexp_flags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_regexp_flags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_regexp_match__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_regexp_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_regexp_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_regexp_replace__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_regexp_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_regexp_replace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_regexp_split__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_regexp_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_regexp_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_regexp_search__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_regexp_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_regexp_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_array_from__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_array_of__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_array_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_array_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_array_copy_within__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_array_copy_within___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_array_copy_within__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_array_find__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_array_find_index__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_array_find_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_array_find_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_array_fill__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_array_fill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_array_fill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_array_iterator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_array_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_array_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_number_is_finite__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_number_is_integer__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_number_is_safe_integer__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_number_is_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_number_is_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_number_is_nan__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_number_epsilon__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_number_epsilon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_number_epsilon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_number_min_safe_integer__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_number_min_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_number_min_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_number_max_safe_integer__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_acosh__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_acosh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_acosh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_asinh__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_asinh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_asinh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_atanh__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_atanh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_atanh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_cbrt__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_cbrt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_cbrt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_clz32__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_clz32___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_clz32__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_cosh__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_cosh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_cosh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_core_js_modules_es6_math_expm1__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_core_js_modules_es6_math_expm1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76_core_js_modules_es6_math_expm1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_core_js_modules_es6_math_fround__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_core_js_modules_es6_math_fround___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77_core_js_modules_es6_math_fround__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_core_js_modules_es6_math_hypot__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_core_js_modules_es6_math_hypot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78_core_js_modules_es6_math_hypot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_core_js_modules_es6_math_imul__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_core_js_modules_es6_math_imul___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79_core_js_modules_es6_math_imul__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_core_js_modules_es6_math_log1p__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_core_js_modules_es6_math_log1p___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80_core_js_modules_es6_math_log1p__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_core_js_modules_es6_math_log10__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_core_js_modules_es6_math_log10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81_core_js_modules_es6_math_log10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_core_js_modules_es6_math_log2__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_core_js_modules_es6_math_log2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82_core_js_modules_es6_math_log2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_core_js_modules_es6_math_sign__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_core_js_modules_es6_math_sign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83_core_js_modules_es6_math_sign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_core_js_modules_es6_math_sinh__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_core_js_modules_es6_math_sinh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84_core_js_modules_es6_math_sinh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_core_js_modules_es6_math_tanh__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_core_js_modules_es6_math_tanh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85_core_js_modules_es6_math_tanh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_core_js_modules_es6_math_trunc__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_core_js_modules_es6_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86_core_js_modules_es6_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87_core_js_modules_es7_array_includes__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87_core_js_modules_es7_array_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87_core_js_modules_es7_array_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88_core_js_modules_es7_object_values__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88_core_js_modules_es7_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88_core_js_modules_es7_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89_core_js_modules_es7_object_entries__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89_core_js_modules_es7_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89_core_js_modules_es7_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90_core_js_modules_es7_object_get_own_property_descriptors__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90_core_js_modules_es7_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_90_core_js_modules_es7_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91_core_js_modules_es7_string_pad_start__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91_core_js_modules_es7_string_pad_start___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_91_core_js_modules_es7_string_pad_start__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92_core_js_modules_es7_string_pad_end__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92_core_js_modules_es7_string_pad_end___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_92_core_js_modules_es7_string_pad_end__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93_core_js_modules_web_timers__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93_core_js_modules_web_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_93_core_js_modules_web_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94_core_js_modules_web_immediate__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94_core_js_modules_web_immediate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_94_core_js_modules_web_immediate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95_core_js_modules_web_dom_iterable__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95_core_js_modules_web_dom_iterable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_95_core_js_modules_web_dom_iterable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96_regenerator_runtime_runtime__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96_regenerator_runtime_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_96_regenerator_runtime_runtime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97_vue__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98_vue_router__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__App__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_99__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__views_Index__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__views_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_100__views_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__views_Ballsaal__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__views_Ballsaal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_101__views_Ballsaal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__views_Co_Working__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__views_Co_Working___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_102__views_Co_Working__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__views_Kaffeehaus__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__views_Kaffeehaus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_103__views_Kaffeehaus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__views_About__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__views_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_104__views_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__views_Kontakt__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__views_Kontakt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_105__views_Kontakt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__assets_scss_main_scss__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__assets_scss_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_106__assets_scss_main_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107_vue_meta__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_107_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108_vue_scrollto__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_108_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109_vue2_google_maps__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_109_vue2_google_maps__);



















































































































__WEBPACK_IMPORTED_MODULE_97_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_97_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_98_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_97_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_107_vue_meta___default.a, {
  keyName: 'head'
});
__WEBPACK_IMPORTED_MODULE_97_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_108_vue_scrollto___default.a);
__WEBPACK_IMPORTED_MODULE_97_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_109_vue2_google_maps__, {
  load: {
    key: 'AIzaSyBN9jXIfpYgHECBPiiKPZ-9xelm-ZGwx3s'
  }
});

var routes = [{ path: '/', name: 'Home', component: __WEBPACK_IMPORTED_MODULE_100__views_Index___default.a }, { path: '/ballsaal', name: 'Ballsaal', component: __WEBPACK_IMPORTED_MODULE_101__views_Ballsaal___default.a }, { path: '/co-working', name: 'Co-Working', component: __WEBPACK_IMPORTED_MODULE_102__views_Co_Working___default.a }, { path: '/kaffeehaus', name: 'Kaffeehaus', component: __WEBPACK_IMPORTED_MODULE_103__views_Kaffeehaus___default.a }, { path: '/hof', name: 'Der Hof', component: __WEBPACK_IMPORTED_MODULE_104__views_About___default.a }, { path: '/kontakt', name: 'Kontakt', component: __WEBPACK_IMPORTED_MODULE_105__views_Kontakt___default.a }];

var router = new __WEBPACK_IMPORTED_MODULE_98_vue_router__["a" /* default */]({
  mode: 'history',
  routes: routes
});

var vm = new __WEBPACK_IMPORTED_MODULE_97_vue__["a" /* default */]({
  el: '#ctn',
  router: router,
  template: '<App ref="app"/>',
  ref: 'app',
  style: __WEBPACK_IMPORTED_MODULE_106__assets_scss_main_scss___default.a,
  components: { App: __WEBPACK_IMPORTED_MODULE_99__App___default.a }
});

router.beforeEach(function (to, from, next) {
  if (document.body.classList.contains('has-nav-open')) {
    vm.$refs.app.$refs.header.toggleNav();
    setTimeout(function () {
      next();
    }, 500);
  } else {
    next();
  }
});

router.afterEach(function () {});

/***/ }),

/***/ 313:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Header__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Nav__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Image__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Background__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Background___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Background__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_gsap__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_js_SplitText_min_js__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_js_SplitText_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_js_SplitText_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_js_DrawSVGPlugin__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_js_DrawSVGPlugin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_js_DrawSVGPlugin__);














__WEBPACK_IMPORTED_MODULE_6_gsap__["TweenLite"].defaultEase = __WEBPACK_IMPORTED_MODULE_6_gsap__["Power3"].easeOut;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    siteHeader: __WEBPACK_IMPORTED_MODULE_2__components_Header___default.a,
    siteNav: __WEBPACK_IMPORTED_MODULE_3__components_Nav___default.a,
    routeImage: __WEBPACK_IMPORTED_MODULE_4__components_Image___default.a,
    routeBackground: __WEBPACK_IMPORTED_MODULE_5__components_Background___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading___default.a
  },
  data: function data() {
    return {
      ready: false,
      title: 'Donauhof Wien',
      description: 'In den Gemäuern des um 1900 errichteten »Hotel Donauhof«, das die letzten Jahrzehnte als Holzlager diente, entsteht Neues.',
      shareImg: 'http://www.donauhofwien.at/share.png',
      shareUrl: 'http://www.donauhofwien.at',
      currentIndicator: this.$refs.page ? this.$refs.page.indicator : null,
      currentImage: this.$refs.page ? this.$refs.page.image : null,
      currentHeadline: null,
      currentBackground: this.$refs.page ? this.$refs.page.background : { rotate: null, scale: { x: null, y: null }, translate: { x: null, y: null } }
    };
  },

  watch: {
    '$route': function $route(to, from) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].$gmapDefaultResizeBus.$emit('resize');
    }
  },
  computed: {
    isMobileData: function isMobileData() {
      return this.isMobile();
    }
  },
  head: function head() {
    return {
      title: '…',
      titleTemplate: '%s ~ Donauhof',
      meta: [{ property: 'og:title', content: this.title }, { property: 'og:description', content: this.description }, { property: 'og:image', content: this.shareImg }, { property: 'og:url', content: this.shareUrl }, { property: 'twitter:site', content: '@donauhofwien' }, { property: 'twitter:creator', content: '@maxschulmeister' }, { property: 'twitter:title', content: this.title }, { property: 'twitter:description', content: this.description }, { property: 'twitter:image', content: this.shareImg }, { property: 'twitter:card', content: 'summary_large_image' }]
    };
  },
  mounted: function mounted() {
    if (this.isMobileData) this.ready = true;
  },

  methods: {
    shapeEnter: function shapeEnter(el, done) {
      __WEBPACK_IMPORTED_MODULE_6_gsap__["TweenLite"].from('.background-shape svg', 3, {
        scale: 0,
        rotationZ: 75,
        ease: __WEBPACK_IMPORTED_MODULE_6_gsap__["Power3"].easeOut,
        onComplete: function onComplete() {
          done();
        }
      });
    },
    enter: function enter(el, done) {
      this.currentHeadline = new __WEBPACK_IMPORTED_MODULE_7__assets_js_SplitText_min_js___default.a(document.querySelector('h1'), { type: 'chars, words', charsClass: 'char', wordsClass: 'word' });
      this.currentIndicator = this.$refs.page.indicator;
      this.currentImage = this.$refs.page.image;
      this.currentBackground = this.$refs.page.background;
      var tl = new __WEBPACK_IMPORTED_MODULE_6_gsap__["TimelineLite"]({
        onComplete: function onComplete() {
          done();
        }
      });
      tl.staggerFromTo(this.currentHeadline.chars, 0.25, { y: 12, autoAlpha: 0 }, { y: -6, autoAlpha: 1 }, 0.0075, 1.5);
      tl.staggerTo(this.currentHeadline.chars, 1, { y: 0 }, 0.0075, 1.75);
      tl.from('.sep svg path', 1.5, { drawSVG: 0 }, '-=1');
      tl.staggerFrom('.body > *', 0.5, { y: 25, rotation: 5, autoAlpha: 0 }, 0.125, '-=1.25');
    },
    leave: function leave(el, done) {
      var tl = new __WEBPACK_IMPORTED_MODULE_6_gsap__["TimelineLite"]({ onComplete: function onComplete() {
          done();
        } });
      tl.to(el, 0.5, { y: 25, rotation: 2, autoAlpha: 0 });
    },
    beforeEnter: function beforeEnter() {
      window.scrollTo(0, 0);
    },
    isMobile: function isMobile() {
      return window.matchMedia('(max-width: 1200px)').matches;
    }
  }
});

/***/ }),

/***/ 314:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['transform'],
  data: function data() {
    return {
      wave: __webpack_require__(112)
    };
  }
});

/***/ }),

/***/ 315:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);



__webpack_require__(398);

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['indicator'],
  data: function data() {
    return {
      logo: __webpack_require__(177),
      contact: __webpack_require__(175),
      revealHeader: false,
      icon: __webpack_require__(176),
      mobileNavOpen: false,
      svg: {
        path: null,
        light_wave: 'M800,66c0,0-58-5-162-5c-164,0-227,9-403,9C102,70,0,66,0,66V0.2h800V66z',
        wave: 'M800,60c0,0-58-11-162-11c-164,0-227,21-403,21C102,70,0,60,0,60V0.2h800V60z',
        rect: 'M800,70c0,0-58-0.5-162-0.5c-164,0-227,0-403,0C102,69.5,0,70,0,70V0h800V70z'
      }
    };
  },

  computed: {
    indicatorPath: function indicatorPath() {
      var el = new DOMParser().parseFromString(this.indicator, 'image/svg+xml').querySelector('path').getAttribute('d');
      return el;
    }
  },
  methods: {
    coordinatesBeforeEnter: function coordinatesBeforeEnter(el) {
      __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenLite"].set(el, { scale: 0, autoAlpha: 0 });
    },
    coordinatesEnter: function coordinatesEnter(el, done) {
      __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenLite"].to(el, 1, {
        scale: 1,
        autoAlpha: 1,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power3"].easeOut,
        onComplete: function onComplete() {
          el.style.transform = '';
          el.style.zIndex = '';
          el.style.opacity = '';
          done();
        }
      });
    },
    indicatorEnter: function indicatorEnter(el, done) {
      var icon = document.querySelector('.indicator .icon');
      icon.style.transition = 'transform 2s cubic-bezier(0.77, 0, 0.175, 1)';
      icon.style.transform = 'scale3d(1,1,1)';
      __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenLite"].to('.indicator svg path', 2, {
        morphSVG: this.indicatorPath,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power3"].easeInOut,
        onComplete: function onComplete() {
          icon.style.transition = '';
          done();
        }
      });
    },
    navAnim: function navAnim(svg, d) {
      __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenLite"].to('.shape svg path', d / 1000, { morphSVG: svg, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power3"].easeInOut });
    },
    toggleNav: function toggleNav(ev) {
      var body = document.body.classList;

      if (body.contains('has-nav-open')) {
        this.navAnim(this.svg.wave, 1000);
        body.toggle('is-closed');
      } else {
        this.navAnim(this.svg.rect, 1000);
        body.remove('is-closed');
      }
      body.toggle('has-nav-open');
      if (this.$parent.isMobile()) {
        var navHeight = document.querySelector('nav').clientHeight;
        this.mobileNavOpen = !this.mobileNavOpen;
        document.querySelector('.wrap > *:not(header)').style.transform = this.mobileNavOpen ? 'translate3d(0,' + navHeight + 'px, 0)' : 'translate3d(0,0,0)';
      }
    },
    toggleNavHover: function toggleNavHover(ev) {
      var _this = this;

      var body = document.body.classList;
      if (!this.$parent.isMobile()) {
        this.revealHeader = !this.revealHeader;
        body.toggle('has-nav-hover');
        body.remove('is-closed');
        if (body.contains('has-nav-open')) {
          if (ev.type === 'mouseenter') {
            this.hover = true;
            setTimeout(function () {
              if (_this.hover) _this.navAnim(_this.svg.light_wave, 500);
            }, 250);
          } else {
            this.hover = false;
            setTimeout(function () {
              if (!_this.hover) _this.navAnim(_this.svg.rect, 500);
            }, 250);
          }
        }
      }
    },
    headerMouseover: function headerMouseover() {
      if (!this.$parent.isMobile()) this.revealHeader = !this.revealHeader;
    }
  }
});

/***/ }),

/***/ 316:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['image'],
  data: function data() {
    return {
      shape: {
        enter: 'M400,500c0,0-17,0-106,0s-97,0-187,0S0,500,0,500V30C0,30,18,0,112,0s100,40,186,40s102-20,102-20V500z',
        leave: 'M400,460c0,0-17,40-106,40s-97-40-187-40S0,490,0,490V0c0,0,18,0,112,0s100,0,186,0s102,0,102,0V460z',
        rect: 'M400,500c0,0-17,0-106,0s-97,0-187,0S0,500,0,500V0c0,0,18,0,112,0s100,0,186,0s102,0,102,0V500z'
      }
    };
  },

  methods: {
    morph: function morph(svgFrom, svgTo, d, x) {
      return __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenLite"].fromTo('.shape-mask path', d / 1000, { morphSVG: svgFrom }, { morphSVG: svgTo, delay: x / 1000, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power3"].easeInOut });
    },
    enter: function enter(el, done) {
      var shape = document.querySelector('.shape-mask');
      shape.style.transformOrigin = 'center bottom';
      __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenLite"].to('.image-ctn', 1, { opacity: 1 });
      __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenLite"].to(shape, 1, {
        scaleY: 0,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power3"].easeInOut,
        onStart: function onStart() {
          shape.style.transformOrigin = 'center bottom';
        },
        onCompleteScope: this,
        onComplete: function onComplete() {
          var _this = this;

          shape.style.transformOrigin = '';
          setTimeout(function () {
            _this.morph(_this.shape.enter, _this.shape.leave, 125, 0);
            done();
          }, 500);
        }
      });
      this.morph(this.shape.rect, this.shape.enter, 500, 250);
    },
    leave: function leave(el, done) {
      var shape = document.querySelector('.shape-mask');

      __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenLite"].to(shape, 1, {
        scaleY: 1,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power3"].easeInOut,
        onComplete: function onComplete() {
          setTimeout(function () {
            done();
          }, 500);
        }
      });
      this.morph(this.shape.leave, this.shape.rect, 500, 250);
    }
  }
});

/***/ }),

/***/ 317:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_DrawSVGPlugin_js__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_DrawSVGPlugin_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_js_DrawSVGPlugin_js__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      wave: __webpack_require__(112),
      logo: __webpack_require__(177),
      images: [__webpack_require__(170), __webpack_require__(171), __webpack_require__(173), __webpack_require__(174), __webpack_require__(172)]
    };
  },
  mounted: function mounted() {
    var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineLite"]({
      onCompleteScope: this,
      onComplete: function onComplete() {
        this.$parent.ready = true;
      }
    });

    tl.set('.wave.light-gold svg path', { stroke: '#fdfaf5' });

    tl.to('.blue', 4, { scaleX: 0.5, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power3"].easeInOut }, 1);
    tl.from('.wave.gold svg path', 3, { drawSVG: '0', ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power3"].easeInOut }, 2);
    tl.staggerFromTo('.wave svg path', 1, { drawSVG: '0 100%' }, { drawSVG: '100% 100%', ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power3"].easeInOut }, -0.25, 5);
    tl.set('.loading, .blue', { background: 'transparent' });
  }
});

/***/ }),

/***/ 318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_SplitText_min_js__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_SplitText_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_js_SplitText_min_js__);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    var els = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(document.querySelectorAll('nav li a')));
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(els), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var el = _step.value;

        var split = new __WEBPACK_IMPORTED_MODULE_3__assets_js_SplitText_min_js___default.a(el, { type: 'chars', charsClass: 'char' });
        split;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  },

  methods: {
    linkHover: function linkHover(ev) {
      var direction = ev.movementX < 0 ? -1 : 1;
      var els = ev.target.querySelectorAll('.char');

      var tl = new __WEBPACK_IMPORTED_MODULE_2_gsap__["TimelineLite"]();
      tl.staggerTo(els, 0.25, { y: -3, ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Back"].easeOut }, 0.031 * direction);
      tl.staggerTo(els, 1, { y: 0, ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Back"].easeOut }, 0.031 * direction, 0.25);
    }
  }
});

/***/ }),

/***/ 319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      wave: __webpack_require__(112)
    };
  }
});

/***/ }),

/***/ 320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Seperator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Seperator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Seperator__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    seperator: __WEBPACK_IMPORTED_MODULE_0__components_Seperator___default.a
  },
  data: function data() {
    return {
      title: 'Kaffeehaus',
      indicator: __webpack_require__(400),
      image: __webpack_require__(170),
      background: {
        rotate: -50,
        scale: {
          x: 2,
          y: 14
        },
        translate: {
          x: '-65%',
          y: '0%'
        }
      },
      headline: 'Der Donauhof soll neben klassischen Vermietungen, Platz für innovative Projekte bieten.',
      body: ['Abseits von Kaffehaus, Ballsaal & Coworking Space, findet in Zukunft auch eine Möbelwerkstatt Einzug in den Donauhof. Ein Beispiel für viele Projekte, die sich durch gemeinsame Arbeit ergeben haben. ', 'Für Ideen zu Kooperationen, gemeinsamen Veranstaltungen & Projekten könnt ihr gerne jederzeit mit uns in Kontakt treten. ']
    };
  },
  head: function head() {
    return {
      title: this.title
    };
  }
});

/***/ }),

/***/ 321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Seperator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Seperator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Seperator__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    seperator: __WEBPACK_IMPORTED_MODULE_0__components_Seperator___default.a
  },
  data: function data() {
    return {
      title: 'Ballsaal',
      indicator: __webpack_require__(401),
      image: __webpack_require__(171),
      background: {
        rotate: 0,
        scale: {
          x: 6,
          y: 8
        },
        translate: {
          x: '-20%',
          y: '30%'
        }
      },
      headline: 'Lange in Vergessenheit geraten und der Öffentlichkeit unbekannt, ist der Ballsaal das Herzstück des Donauhofs.',
      body: ['Der sich in Renovierung befindende Ballsaal erinnert an den Glanz alter Zeiten ohne überheblich zu wirken. Veranstaltungen aller Art finden hier ihren Platz. Die Renovierung der 400m<sup>2</sup> wird dieses Jahr abgeschlossen. Vereinzelt können auch Veranstaltungen vor der Fertigstellung stattfinden.'],
      email: 'office@donauhofwien.at'
    };
  },
  head: function head() {
    return {
      title: this.title
    };
  }
});

/***/ }),

/***/ 322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      title: 'Co-Working',
      indicator: __webpack_require__(403),
      image: __webpack_require__(173),
      background: {
        rotate: -90,
        scale: {
          x: 3,
          y: 12
        },
        translate: {
          x: '-65%',
          y: '15%'
        }
      },
      headline: 'Zwischen neuen Arbeitswelten und altem Wiener Büro. Start November 2017.',
      plans: [{
        title: 'Dayticket',
        price: '15',
        span: 'Tag'
      }, {
        title: 'Flex Desk ab',
        price: '160',
        span: 'Monat'
      }, {
        title: 'Fix Desk ab',
        price: '240',
        span: 'Monat'
      }],
      email: 'coworking@donauhofwien.at',
      info: 'alle Preise in Euro<br>und exklusive Mehrwertsteuer.'
    };
  },
  head: function head() {
    return {
      title: this.title
    };
  }
});

/***/ }),

/***/ 323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Seperator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Seperator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Seperator__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    seperator: __WEBPACK_IMPORTED_MODULE_0__components_Seperator___default.a
  },
  data: function data() {
    return {
      title: 'Donauhof Wien',
      indicator: __webpack_require__(176),
      image: __webpack_require__(174),
      background: {
        rotate: 45,
        scale: {
          x: 4,
          y: 4
        },
        translate: {
          x: '-15%',
          y: '-30%'
        }
      },
      headline: 'In den Gemäuern des um 1900 errichteten »Hotel Donauhof«, das die letzten Jahrzehnte als Holzlager diente, entsteht Neues.',
      body: ['Durch die Revitalisierung des Donauhofs entstehen im zweiten Wiener Gemeindebezirk auf über 1000m<sup>2</sup> ein Eventspace (im alten Ballsaal des Hotels), das Kaffeehaus Donauhof, sowie ein Coworking Space & Werkstätten.', 'Im Donauhof sollen Nachbarschaft, soziale & innovative Projekte und Start Ups ihren Platz finden.']
    };
  },
  head: function head() {
    return {
      title: this.title,
      titleTemplate: '%s'
    };
  }
});

/***/ }),

/***/ 324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Seperator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Seperator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Seperator__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    seperator: __WEBPACK_IMPORTED_MODULE_1__components_Seperator___default.a
  },
  data: function data() {
    return {
      title: 'Kaffeehaus',
      indicator: __webpack_require__(402),
      image: __webpack_require__(172),
      background: {
        rotate: -60,
        scale: {
          x: 4,
          y: 16
        },
        translate: {
          x: '-50%',
          y: '0%'
        }
      },
      headline: '2018 bekommt der Donauhof ein Kaffeehaus.',
      body: ['Die Räumlichkeiten sind für vereinzelte Veranstaltungen schon dieses Jahr mietbar (Auch in Kombination mit dem Ballsaal).', 'Wir halten euch gerne auf dem Laufenden.'],
      form: {
        name: '',
        email: '',
        response: false
      }
    };
  },
  head: function head() {
    return {
      title: this.title
    };
  },

  methods: {
    submitForm: function submitForm() {
      var self = this;
      var form = document.querySelector('form');
      var formdata = new FormData(form);
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(form.getAttribute('action'), formdata).then(function (response) {
        console.log(response);
        self.form.response = response.data;
        setTimeout(function () {
          self.form.response = false;
          self.form.email = '';
          self.form.name = '';
        }, 30000);
      }).catch(function (error) {
        console.log(error);
        self.form.response = error.data;
      });
    }
  }
});

/***/ }),

/***/ 325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      title: 'Kontakt',
      indicator: __webpack_require__(175),

      image: {
        src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAFAQMAAABYY9+YAAAAA1BMVEXt9/YJY156AAAACklEQVQI12OAAwAACgABaQY5MgAAAABJRU5ErkJggg==',
        center: {
          lat: 48.231665,
          lng: 16.394992
        },
        marker: {
          fontFamily: 'GT Haptik',
          fontWeight: 'bold',
          text: '0',
          color: 'rgba(218,149, 51, 1)',
          fontSize: '32px'
        },
        options: {
          styles: [{ "featureType": "all", "elementType": "labels.text.fill", "stylers": [{ "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 }] }, { "featureType": "all", "elementType": "labels.text.stroke", "stylers": [{ "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 }] }, { "featureType": "all", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [{ "color": "#fdfaf5" }, { "lightness": "0" }, { "gamma": "1" }] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#fdfaf5" }, { "lightness": "0" }, { "weight": 1.2 }, { "gamma": "1" }] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [{ "color": "#fdfaf5" }, { "lightness": "0" }, { "gamma": "1.00" }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#da9533" }, { "lightness": "75" }, { "gamma": "1.00" }] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#da9533" }, { "lightness": "75" }, { "gamma": "1.00" }, { "saturation": "0" }, { "weight": "1" }] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#333333" }, { "lightness": "95" }, { "gamma": "1" }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#333333" }, { "lightness": "95" }, { "weight": 0.2 }] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#333333" }, { "lightness": "95" }, { "gamma": "1" }] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [{ "color": "#333333" }, { "lightness": "95" }, { "gamma": "1" }] }, { "featureType": "transit", "elementType": "geometry", "stylers": [{ "color": "#da9533" }, { "lightness": "50" }] }, { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#edf7f6" }, { "lightness": "0" }, { "gamma": "1" }] }],

          backgroundColor: '#edf7f6',
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          scrollwheel: true,
          fullscreenControl: false
        }
      },
      background: {
        rotate: 130,
        scale: {
          x: 2,
          y: 2
        },
        translate: {
          x: '-50%',
          y: '-450%'
        }
      },
      headline: 'Die Donau fließt durch viele Städte – vor allem aber durch Wien und zu uns.',
      body: {
        address: {
          name: 'Donauhof Wien',
          logo: __webpack_require__(404),
          street: 'Engerthstraße 141,<br>A-1020 Wien'
        },
        contact: {
          email: 'office@donauhofwien.at',
          tel: {
            raw: '00436769731617',
            nice: '+43 676 973 16 17'
          }
        },
        legal: ['Firmenbuchnummer: FN 293622 y', 'Handelsgericht Wien', 'Ust-ID: ATU63400947']
      }
    };
  },
  head: function head() {
    return {
      title: this.title
    };
  }
});

/***/ }),

/***/ 378:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 379:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 380:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 381:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 382:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 383:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 384:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 385:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 386:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 387:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 388:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 389:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 390:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 391:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 392:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 396:
/***/ (function(module, exports) {

module.exports = "var _gsScope = (typeof(module) !== \"undefined\" && module.exports && typeof(global) !== \"undefined\") ? global : this || window; //helps ensure compatibility with AMD/RequireJS and CommonJS/Node\n(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push( function() {\n\n\t\"use strict\";\n\n\n\tvar _DEG2RAD = Math.PI / 180,\n\t\t_RAD2DEG = 180 / Math.PI,\n\t\t_svgPathExp = /[achlmqstvz]|(-?\\d*\\.?\\d*(?:e[\\-+]?\\d+)?)[0-9]/ig,\n\t\t_numbersExp = /(?:(-|-=|\\+=)?\\d*\\.?\\d*(?:e[\\-+]?\\d+)?)[0-9]/ig,\n\t\t_selectorExp = /(^[#\\.]|[a-y][a-z])/gi,\n\t\t_commands = /[achlmqstvz]/ig,\n\t\t_scientific = /[\\+\\-]?\\d*\\.?\\d+e[\\+\\-]?\\d+/ig,\n\t\t//_attrExp = /(\\S+)=[\"']?((?:.(?![\"']?\\s+(?:\\S+)=|[>\"']))+.)[\"']?/gi, //finds all the attribute name/value pairs in an HTML element\n\t\t//_outerTagExp = /^<([A-Za-z0-9_\\-]+)((?:\\s+[A-Za-z0-9_\\-]+(?:\\s*=\\s*(?:(?:\"[^\"]*\")|(?:'[^']*')|[^>\\s]+))?)*)\\s*(\\/?)>/i, //takes the outerHTML and pulls out [0] - the first tag, [1] - the tag name, and [2] - the attribute name/value pairs (space-delimited)\n\t\t//_wrappingQuotesExp = /^[\"']|[\"']$/g,\n\t\tTweenLite = _gsScope._gsDefine.globals.TweenLite,\n\t\t//_nonNumbersExp = /(?:([\\-+](?!(\\d|=)))|[^\\d\\-+=e]|(e(?![\\-+][\\d])))+/ig,\n\n\t\t_log = function(message) {\n\t\t\tif (_gsScope.console) {\n\t\t\t\tconsole.log(message);\n\t\t\t}\n\t\t},\n\n\t\t// translates an arc into a normalized array of cubic beziers excluding the starting x/y. The circle the arc follows will be centered at 0,0 and have a radius of 1 (hence normalized). Each bezier covers no more than 90 degrees; the arc will be divided evenly into a maximum of four curves.\n\t\t_normalizedArcToBeziers = function(angleStart, angleExtent) {\n\t\t\tvar segments = Math.ceil(Math.abs(angleExtent) / 90),\n\t\t\t\tl = 0,\n\t\t\t\ta = [],\n\t\t\t\tangleIncrement, controlLength, angle, dx, dy, i;\n\t\t\tangleStart *= _DEG2RAD;\n\t\t\tangleExtent *= _DEG2RAD;\n\t\t\tangleIncrement = angleExtent / segments;\n\t\t\tcontrolLength = 4 / 3 * Math.sin(angleIncrement / 2) / (1 + Math.cos(angleIncrement / 2));\n\t\t\tfor (i = 0; i < segments; i++) {\n\t\t\t\tangle = angleStart + i * angleIncrement;\n\t\t\t\tdx = Math.cos(angle);\n\t\t\t\tdy = Math.sin(angle);\n\t\t\t\ta[l++] = dx - controlLength * dy;\n\t\t\t\ta[l++] = dy + controlLength * dx;\n\t\t\t\tangle += angleIncrement;\n\t\t\t\tdx = Math.cos(angle);\n\t\t\t\tdy = Math.sin(angle);\n\t\t\t\ta[l++] = dx + controlLength * dy;\n\t\t\t\ta[l++] = dy - controlLength * dx;\n\t\t\t\ta[l++] = dx;\n\t\t\t\ta[l++] = dy;\n\t\t\t}\n\t\t\treturn a;\n\t\t},\n\n\t\t// translates SVG arc data into an array of cubic beziers\n\t\t_arcToBeziers = function(lastX, lastY, rx, ry, angle, largeArcFlag, sweepFlag, x, y) {\n\t\t\tif (lastX === x && lastY === y) {\n\t\t\t\treturn;\n\t\t\t}\n\t\t\trx = Math.abs(rx);\n\t\t\try = Math.abs(ry);\n\t\t\tvar angleRad = (angle % 360) * _DEG2RAD,\n\t\t\t\tcosAngle = Math.cos(angleRad),\n\t\t\t\tsinAngle = Math.sin(angleRad),\n\t\t\t\tdx2 = (lastX - x) / 2,\n\t\t\t\tdy2 = (lastY - y) / 2,\n\t\t\t\tx1 = (cosAngle * dx2 + sinAngle * dy2),\n\t\t\t\ty1 = (-sinAngle * dx2 + cosAngle * dy2),\n\t\t\t\trx_sq = rx * rx,\n\t\t\t\try_sq = ry * ry,\n\t\t\t\tx1_sq = x1 * x1,\n\t\t\t\ty1_sq = y1 * y1,\n\t\t\t\tradiiCheck = x1_sq / rx_sq + y1_sq / ry_sq;\n\t\t\tif (radiiCheck > 1) {\n\t\t\t\trx = Math.sqrt(radiiCheck) * rx;\n\t\t\t\try = Math.sqrt(radiiCheck) * ry;\n\t\t\t\trx_sq = rx * rx;\n\t\t\t\try_sq = ry * ry;\n\t\t\t}\n\t\t\tvar sign = (largeArcFlag === sweepFlag) ? -1 : 1,\n\t\t\t\tsq = ((rx_sq * ry_sq) - (rx_sq * y1_sq) - (ry_sq * x1_sq)) / ((rx_sq * y1_sq) + (ry_sq * x1_sq));\n\t\t\tif (sq < 0) {\n\t\t\t\tsq = 0;\n\t\t\t}\n\t\t\tvar coef = (sign * Math.sqrt(sq)),\n\t\t\t\tcx1 = coef * ((rx * y1) / ry),\n\t\t\t\tcy1 = coef * -((ry * x1) / rx),\n\t\t\t\tsx2 = (lastX + x) / 2,\n\t\t\t\tsy2 = (lastY + y) / 2,\n\t\t\t\tcx = sx2 + (cosAngle * cx1 - sinAngle * cy1),\n\t\t\t\tcy = sy2 + (sinAngle * cx1 + cosAngle * cy1),\n\t\t\t\tux = (x1 - cx1) / rx,\n\t\t\t\tuy = (y1 - cy1) / ry,\n\t\t\t\tvx = (-x1 - cx1) / rx,\n\t\t\t\tvy = (-y1 - cy1) / ry,\n\t\t\t\tn = Math.sqrt((ux * ux) + (uy * uy)),\n\t\t\t\tp = ux;\n\t\t\tsign = (uy < 0) ? -1 : 1;\n\t\t\tvar angleStart = (sign * Math.acos(p / n)) * _RAD2DEG;\n\n\t\t\tn = Math.sqrt((ux * ux + uy * uy) * (vx * vx + vy * vy));\n\t\t\tp = ux * vx + uy * vy;\n\t\t\tsign = (ux * vy - uy * vx < 0) ? -1 : 1;\n\t\t\tvar angleExtent = (sign * Math.acos(p / n)) * _RAD2DEG;\n\t\t\tif (!sweepFlag && angleExtent > 0) {\n\t\t\t\tangleExtent -= 360;\n\t\t\t} else if (sweepFlag && angleExtent < 0) {\n\t\t\t\tangleExtent += 360;\n\t\t\t}\n\t\t\tangleExtent %= 360;\n\t\t\tangleStart %= 360;\n\n\t\t\tvar bezierPoints = _normalizedArcToBeziers(angleStart, angleExtent),\n\t\t\t\ta = cosAngle * rx,\n\t\t\t\tb = sinAngle * rx,\n\t\t\t\tc = sinAngle * -ry,\n\t\t\t\td = cosAngle * ry,\n\t\t\t\tl = bezierPoints.length - 2,\n\t\t\t\ti, px, py;\n\t\t\t//translate all the bezier points according to the matrix...\n\t\t\tfor (i = 0; i < l; i +=  2) {\n\t\t\t\tpx = bezierPoints[i];\n\t\t\t\tpy = bezierPoints[i+1];\n\t\t\t\tbezierPoints[i] = px * a + py * c + cx;\n\t\t\t\tbezierPoints[i+1] = px * b + py * d + cy;\n\t\t\t}\n\t\t\tbezierPoints[bezierPoints.length-2] = x; //always set the end to exactly where it's supposed to be\n\t\t\tbezierPoints[bezierPoints.length-1] = y;\n\t\t\treturn bezierPoints;\n\t\t},\n\n\t\t//Spits back an array of cubic Bezier segments that use absolute coordinates. Each segment starts with a \"moveTo\" command (x coordinate, then y) and then 2 control points (x, y, x, y), then anchor. The goal is to minimize memory and maximize speed.\n\t\t_pathDataToBezier = function(d) {\n\t\t\tvar a = (d + \"\").replace(_scientific, function(m) { var n = +m; return (n < 0.0001 && n > -0.0001) ? 0 : n; }).match(_svgPathExp) || [], //some authoring programs spit out very small numbers in scientific notation like \"1e-5\", so make sure we round that down to 0 first.\n\t\t\t\tpath = [],\n\t\t\t\trelativeX = 0,\n\t\t\t\trelativeY = 0,\n\t\t\t\telements = a.length,\n\t\t\t\tl = 2,\n\t\t\t\tpoints = 0,\n\t\t\t\ti, j, x, y, command, isRelative, segment, startX, startY, difX, difY, beziers, prevCommand;\n\t\t\tif (!d || !isNaN(a[0]) || isNaN(a[1])) {\n\t\t\t\t_log(\"ERROR: malformed path data: \" + d);\n\t\t\t\treturn path;\n\t\t\t}\n\t\t\tfor (i = 0; i < elements; i++) {\n\t\t\t\tprevCommand = command;\n\t\t\t\tif (isNaN(a[i])) {\n\t\t\t\t\tcommand = a[i].toUpperCase();\n\t\t\t\t\tisRelative = (command !== a[i]); //lower case means relative\n\t\t\t\t} else { //commands like \"C\" can be strung together without any new command characters between.\n\t\t\t\t\ti--;\n\t\t\t\t}\n\t\t\t\tx = +a[i+1];\n\t\t\t\ty = +a[i+2];\n\t\t\t\tif (isRelative) {\n\t\t\t\t\tx += relativeX;\n\t\t\t\t\ty += relativeY;\n\t\t\t\t}\n\t\t\t\tif (i === 0) {\n\t\t\t\t\tstartX = x;\n\t\t\t\t\tstartY = y;\n\t\t\t\t}\n\n\t\t\t\t// \"M\" (move)\n\t\t\t\tif (command === \"M\") {\n\t\t\t\t\tif (segment && segment.length < 8) { //if the path data was funky and just had a M with no actual drawing anywhere, skip it.\n\t\t\t\t\t\tpath.length-=1;\n\t\t\t\t\t\tl = 0;\n\t\t\t\t\t}\n\t\t\t\t\trelativeX = startX = x;\n\t\t\t\t\trelativeY = startY = y;\n\t\t\t\t\tsegment = [x, y];\n\t\t\t\t\tpoints += l;\n\t\t\t\t\tl = 2;\n\t\t\t\t\tpath.push(segment);\n\t\t\t\t\ti += 2;\n\t\t\t\t\tcommand = \"L\"; //an \"M\" with more than 2 values gets interpreted as \"lineTo\" commands (\"L\").\n\n\t\t\t\t// \"C\" (cubic bezier)\n\t\t\t\t} else if (command === \"C\") {\n\t\t\t\t\tif (!segment) {\n\t\t\t\t\t\tsegment = [0, 0];\n\t\t\t\t\t}\n\t\t\t\t\tsegment[l++] = x;\n\t\t\t\t\tsegment[l++] = y;\n\t\t\t\t\tif (!isRelative) {\n\t\t\t\t\t\trelativeX = relativeY = 0;\n\t\t\t\t\t}\n\t\t\t\t\tsegment[l++] = relativeX + a[i + 3] * 1; //note: \"*1\" is just a fast/short way to cast the value as a Number. WAAAY faster in Chrome, slightly slower in Firefox.\n\t\t\t\t\tsegment[l++] = relativeY + a[i + 4] * 1;\n\t\t\t\t\tsegment[l++] = relativeX = relativeX + a[i + 5] * 1;\n\t\t\t\t\tsegment[l++] = relativeY = relativeY + a[i + 6] * 1;\n\t\t\t\t\t//if (y === segment[l-1] && y === segment[l-3] && x === segment[l-2] && x === segment[l-4]) { //if all the values are the same, eliminate the waste.\n\t\t\t\t\t//\tsegment.length = l = l-6;\n\t\t\t\t\t//}\n\t\t\t\t\ti += 6;\n\n\t\t\t\t// \"S\" (continuation of cubic bezier)\n\t\t\t\t} else if (command === \"S\") {\n\t\t\t\t\tif (prevCommand === \"C\" || prevCommand === \"S\") {\n\t\t\t\t\t\tdifX = relativeX - segment[l - 4];\n\t\t\t\t\t\tdifY = relativeY - segment[l - 3];\n\t\t\t\t\t\tsegment[l++] = relativeX + difX;\n\t\t\t\t\t\tsegment[l++] = relativeY + difY;\n\t\t\t\t\t} else {\n\t\t\t\t\t\tsegment[l++] = relativeX;\n\t\t\t\t\t\tsegment[l++] = relativeY;\n\t\t\t\t\t}\n\t\t\t\t\tsegment[l++] = x;\n\t\t\t\t\tsegment[l++] = y;\n\t\t\t\t\tif (!isRelative) {\n\t\t\t\t\t\trelativeX = relativeY = 0;\n\t\t\t\t\t}\n\t\t\t\t\tsegment[l++] = relativeX = relativeX + a[i + 3] * 1;\n\t\t\t\t\tsegment[l++] = relativeY = relativeY + a[i + 4] * 1;\n\t\t\t\t\t//if (y === segment[l-1] && y === segment[l-3] && x === segment[l-2] && x === segment[l-4]) { //if all the values are the same, eliminate the waste.\n\t\t\t\t\t//\tsegment.length = l = l-6;\n\t\t\t\t\t//}\n\t\t\t\t\ti += 4;\n\n\t\t\t\t// \"Q\" (quadratic bezier)\n\t\t\t\t} else if (command === \"Q\") {\n\t\t\t\t\tdifX = x - relativeX;\n\t\t\t\t\tdifY = y - relativeY;\n\t\t\t\t\tsegment[l++] = relativeX + difX * 2 / 3;\n\t\t\t\t\tsegment[l++] = relativeY + difY * 2 / 3;\n\t\t\t\t\tif (!isRelative) {\n\t\t\t\t\t\trelativeX = relativeY = 0;\n\t\t\t\t\t}\n\t\t\t\t\trelativeX = relativeX + a[i + 3] * 1;\n\t\t\t\t\trelativeY = relativeY + a[i + 4] * 1;\n\t\t\t\t\tdifX = x - relativeX;\n\t\t\t\t\tdifY = y - relativeY;\n\t\t\t\t\tsegment[l++] = relativeX + difX * 2 / 3;\n\t\t\t\t\tsegment[l++] = relativeY + difY * 2 / 3;\n\t\t\t\t\tsegment[l++] = relativeX;\n\t\t\t\t\tsegment[l++] = relativeY;\n\n\t\t\t\t\ti += 4;\n\n\t\t\t\t// \"T\" (continuation of quadratic bezier)\n\t\t\t\t} else if (command === \"T\") {\n\t\t\t\t\tdifX = relativeX - segment[l-4];\n\t\t\t\t\tdifY = relativeY - segment[l-3];\n\t\t\t\t\tsegment[l++] = relativeX + difX;\n\t\t\t\t\tsegment[l++] = relativeY + difY;\n\t\t\t\t\tdifX = (relativeX + difX * 1.5) - x;\n\t\t\t\t\tdifY = (relativeY + difY * 1.5) - y;\n\t\t\t\t\tsegment[l++] = x + difX * 2 / 3;\n\t\t\t\t\tsegment[l++] = y + difY * 2 / 3;\n\t\t\t\t\tsegment[l++] = relativeX = x;\n\t\t\t\t\tsegment[l++] = relativeY = y;\n\n\t\t\t\t\ti += 2;\n\n\t\t\t\t// \"H\" (horizontal line)\n\t\t\t\t} else if (command === \"H\") {\n\t\t\t\t\ty = relativeY;\n\t\t\t\t\t//if (x !== relativeX) {\n\t\t\t\t\t\tsegment[l++] = relativeX + (x - relativeX) / 3;\n\t\t\t\t\t\tsegment[l++] = relativeY + (y - relativeY) / 3;\n\t\t\t\t\t\tsegment[l++] = relativeX + (x - relativeX) * 2 / 3;\n\t\t\t\t\t\tsegment[l++] = relativeY + (y - relativeY) * 2 / 3;\n\t\t\t\t\t\tsegment[l++] = relativeX = x;\n\t\t\t\t\t\tsegment[l++] = y;\n\t\t\t\t\t//}\n\t\t\t\t\ti += 1;\n\n\t\t\t\t// \"V\" (horizontal line)\n\t\t\t\t} else if (command === \"V\") {\n\t\t\t\t\ty = x; //adjust values because the first (and only one) isn't x in this case, it's y.\n\t\t\t\t\tx = relativeX;\n\t\t\t\t\tif (isRelative) {\n\t\t\t\t\t\ty += relativeY - relativeX;\n\t\t\t\t\t}\n\t\t\t\t\t//if (y !== relativeY) {\n\t\t\t\t\t\tsegment[l++] = x;\n\t\t\t\t\t\tsegment[l++] = relativeY + (y - relativeY) / 3;\n\t\t\t\t\t\tsegment[l++] = x;\n\t\t\t\t\t\tsegment[l++] = relativeY + (y - relativeY) * 2 / 3;\n\t\t\t\t\t\tsegment[l++] = x;\n\t\t\t\t\t\tsegment[l++] = relativeY = y;\n\t\t\t\t\t//}\n\t\t\t\t\ti += 1;\n\n\t\t\t\t// \"L\" (line) or \"Z\" (close)\n\t\t\t\t} else if (command === \"L\" || command === \"Z\") {\n\t\t\t\t\tif (command === \"Z\") {\n\t\t\t\t\t\tx = startX;\n\t\t\t\t\t\ty = startY;\n\t\t\t\t\t\tsegment.closed = true;\n\t\t\t\t\t}\n\t\t\t\t\tif (command === \"L\" || Math.abs(relativeX - x) > 0.5 || Math.abs(relativeY - y) > 0.5) {\n\t\t\t\t\t\tsegment[l++] = relativeX + (x - relativeX) / 3;\n\t\t\t\t\t\tsegment[l++] = relativeY + (y - relativeY) / 3;\n\t\t\t\t\t\tsegment[l++] = relativeX + (x - relativeX) * 2 / 3;\n\t\t\t\t\t\tsegment[l++] = relativeY + (y - relativeY) * 2 / 3;\n\t\t\t\t\t\tsegment[l++] = x;\n\t\t\t\t\t\tsegment[l++] = y;\n\t\t\t\t\t\tif (command === \"L\") {\n\t\t\t\t\t\t\ti += 2;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\trelativeX = x;\n\t\t\t\t\trelativeY = y;\n\n\t\t\t\t// \"A\" (arc)\n\t\t\t\t} else if (command === \"A\") {\n\t\t\t\t\tbeziers = _arcToBeziers(relativeX, relativeY, a[i+1]*1, a[i+2]*1, a[i+3]*1, a[i+4]*1, a[i+5]*1, (isRelative ? relativeX : 0) + a[i+6]*1, (isRelative ? relativeY : 0) + a[i+7]*1);\n\t\t\t\t\tif (beziers) {\n\t\t\t\t\t\tfor (j = 0; j < beziers.length; j++) {\n\t\t\t\t\t\t\tsegment[l++] = beziers[j];\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\trelativeX = segment[l-2];\n\t\t\t\t\trelativeY = segment[l-1];\n\t\t\t\t\ti += 7;\n\n\t\t\t\t} else {\n\t\t\t\t\t_log(\"Error: malformed path data: \" + d);\n\t\t\t\t}\n\t\t\t}\n\t\t\tpath.totalPoints = points + l;\n\t\t\treturn path;\n\t\t},\n\n\t\t//adds a certain number of Beziers while maintaining the path shape (so that the start/end values can have a matching quantity of points to animate). Only pass in ONE segment of the Bezier at a time. Format: [xAnchor, yAnchor, xControlPoint1, yControlPoint1, xControlPoint2, yControlPoint2, xAnchor, yAnchor, xControlPoint1, etc...]\n\t\t_subdivideBezier = function(bezier, quantity) {\n\t\t\tvar tally = 0,\n\t\t\t\tmax = 0.999999,\n\t\t\t\tl = bezier.length,\n\t\t\t\tnewPointsPerSegment = quantity / ((l - 2) / 6),\n\t\t\t\tax, ay, cp1x, cp1y, cp2x, cp2y, bx, by,\n\t\t\t\tx1, y1, x2, y2, i, t;\n\t\t\tfor (i = 2; i < l; i += 6) {\n\t\t\t\ttally += newPointsPerSegment;\n\t\t\t\twhile (tally > max) { //compare with 0.99999 instead of 1 in order to prevent rounding errors\n\t\t\t\t\tax = bezier[i-2];\n\t\t\t\t\tay = bezier[i-1];\n\t\t\t\t\tcp1x = bezier[i];\n\t\t\t\t\tcp1y = bezier[i+1];\n\t\t\t\t\tcp2x = bezier[i+2];\n\t\t\t\t\tcp2y = bezier[i+3];\n\t\t\t\t\tbx = bezier[i+4];\n\t\t\t\t\tby = bezier[i+5];\n\t\t\t\t\tt = 1 / (Math.floor(tally) + 1); //progress along the bezier (value between 0 and 1)\n\n\t\t\t\t\tx1 = ax + (cp1x - ax) * t;\n\t\t\t\t\tx2 = cp1x + (cp2x - cp1x) * t;\n\t\t\t\t\tx1 += (x2 - x1) * t;\n\t\t\t\t\tx2 += ((cp2x + (bx - cp2x) * t) - x2) * t;\n\n\t\t\t\t\ty1 = ay + (cp1y - ay) * t;\n\t\t\t\t\ty2 = cp1y + (cp2y - cp1y) * t;\n\t\t\t\t\ty1 += (y2 - y1) * t;\n\t\t\t\t\ty2 += ((cp2y + (by - cp2y) * t) - y2) * t;\n\n\t\t\t\t\tbezier.splice(i, 4,\n\t\t\t\t\t\tax + (cp1x - ax) * t,   //first control point\n\t\t\t\t\t\tay + (cp1y - ay) * t,\n\t\t\t\t\t\tx1,                     //second control point\n\t\t\t\t\t\ty1,\n\t\t\t\t\t\tx1 + (x2 - x1) * t,     //new fabricated anchor on line\n\t\t\t\t\t\ty1 + (y2 - y1) * t,\n\t\t\t\t\t\tx2,                     //third control point\n\t\t\t\t\t\ty2,\n\t\t\t\t\t\tcp2x + (bx - cp2x) * t, //fourth control point\n\t\t\t\t\t\tcp2y + (by - cp2y) * t\n\t\t\t\t\t);\n\t\t\t\t\ti += 6;\n\t\t\t\t\tl += 6;\n\t\t\t\t\ttally--;\n\t\t\t\t}\n\t\t\t}\n\t\t\treturn bezier;\n\t\t},\n\t\t_bezierToPathData = function(beziers) {\n\t\t\tvar data = \"\",\n\t\t\t\tl = beziers.length,\n\t\t\t\trnd = 100,\n\t\t\t\tsl, s, i, segment;\n\t\t\tfor (s = 0; s < l; s++) {\n\t\t\t\tsegment = beziers[s];\n\t\t\t\tdata += \"M\" + segment[0] + \",\" + segment[1] + \" C\";\n\t\t\t\tsl = segment.length;\n\t\t\t\tfor (i = 2; i < sl; i++) {\n\t\t\t\t\tdata += (((segment[i++] * rnd) | 0) / rnd) + \",\" + (((segment[i++] * rnd) | 0) / rnd) + \" \" + (((segment[i++] * rnd) | 0) / rnd) + \",\" + (((segment[i++] * rnd) | 0) / rnd) + \" \" + (((segment[i++] * rnd) | 0) / rnd) + \",\" + (((segment[i] * rnd) | 0) / rnd) + \" \";\n\t\t\t\t}\n\t\t\t\tif (segment.closed) {\n\t\t\t\t\tdata += \"z\";\n\t\t\t\t}\n\t\t\t}\n\t\t\treturn data;\n\t\t},\n\t\t_reverseBezier = function(bezier) {\n\t\t\tvar a = [],\n\t\t\t\ti = bezier.length - 1,\n\t\t\t\tl = 0;\n\t\t\twhile (--i > -1) {\n\t\t\t\ta[l++] = bezier[i];\n\t\t\t\ta[l++] = bezier[i+1];\n\t\t\t\ti--;\n\t\t\t}\n\t\t\tfor (i = 0; i < l; i++) {\n\t\t\t\tbezier[i] = a[i];\n\t\t\t}\n\t\t\tbezier.reversed = bezier.reversed ? false : true;\n\t\t},\n\t\t_getAverageXY = function(bezier) {\n\t\t\tvar l = bezier.length,\n\t\t\t\tx = 0,\n\t\t\t\ty = 0,\n\t\t\t\ti;\n\t\t\tfor (i = 0; i < l; i++) {\n\t\t\t\tx += bezier[i++];\n\t\t\t\ty += bezier[i];\n\t\t\t}\n\t\t\treturn [x / (l / 2), y / (l / 2)];\n\t\t},\n\t\t_getSize = function(bezier) { //rough estimate of the bounding box (based solely on the anchors) of a single segment. sets \"size\", \"centerX\", and \"centerY\" properties on the bezier array itself, and returns the size (width * height)\n\t\t\tvar l = bezier.length,\n\t\t\t\txMax = bezier[0],\n\t\t\t\txMin = xMax,\n\t\t\t\tyMax = bezier[1],\n\t\t\t\tyMin = yMax,\n\t\t\t\tx, y, i;\n\t\t\tfor (i = 6; i < l; i+=6) {\n\t\t\t\tx = bezier[i];\n\t\t\t\ty = bezier[i+1];\n\t\t\t\tif (x > xMax) {\n\t\t\t\t\txMax = x;\n\t\t\t\t} else if (x < xMin) {\n\t\t\t\t\txMin = x;\n\t\t\t\t}\n\t\t\t\tif (y > yMax) {\n\t\t\t\t\tyMax = y;\n\t\t\t\t} else if (y < yMin) {\n\t\t\t\t\tyMin = y;\n\t\t\t\t}\n\t\t\t}\n\t\t\tbezier.centerX = (xMax + xMin) / 2;\n\t\t\tbezier.centerY = (yMax + yMin) / 2;\n\t\t\treturn (bezier.size = (xMax - xMin) * (yMax - yMin));\n\t\t},\n\t\t_getTotalSize = function(bezier) { //rough estimate of the bounding box of the entire list of Bezier segments (based solely on the anchors). sets \"size\", \"centerX\", and \"centerY\" properties on the bezier array itself, and returns the size (width * height)\n\t\t\tvar segment = bezier.length,\n\t\t\t\txMax = bezier[0][0],\n\t\t\t\txMin = xMax,\n\t\t\t\tyMax = bezier[0][1],\n\t\t\t\tyMin = yMax,\n\t\t\t\tl, x, y, i, b;\n\t\t\twhile (--segment > -1) {\n\t\t\t\tb = bezier[segment];\n\t\t\t\tl = b.length;\n\t\t\t\tfor (i = 6; i < l; i+=6) {\n\t\t\t\t\tx = b[i];\n\t\t\t\t\ty = b[i+1];\n\t\t\t\t\tif (x > xMax) {\n\t\t\t\t\t\txMax = x;\n\t\t\t\t\t} else if (x < xMin) {\n\t\t\t\t\t\txMin = x;\n\t\t\t\t\t}\n\t\t\t\t\tif (y > yMax) {\n\t\t\t\t\t\tyMax = y;\n\t\t\t\t\t} else if (y < yMin) {\n\t\t\t\t\t\tyMin = y;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\tbezier.centerX = (xMax + xMin) / 2;\n\t\t\tbezier.centerY = (yMax + yMin) / 2;\n\t\t\treturn (bezier.size = (xMax - xMin) * (yMax - yMin));\n\t\t},\n\t\t_sortByComplexity = function(a, b) {\n\t\t\treturn b.length - a.length;\n\t\t},\n\t\t_sortBySize = function(a, b) {\n\t\t\tvar sizeA = a.size || _getSize(a),\n\t\t\t\tsizeB = b.size || _getSize(b);\n\t\t\treturn (Math.abs(sizeB - sizeA) < (sizeA + sizeB) / 20) ? (b.centerX - a.centerX) || (b.centerY - a.centerY) : sizeB - sizeA; //if the size is within 10% of each other, prioritize position from left to right, then top to bottom.\n\t\t},\n\t\t_offsetBezier = function(bezier, shapeIndex) {\n\t\t\tvar a = bezier.slice(0),\n\t\t\t\tl = bezier.length,\n\t\t\t\twrap = l - 2,\n\t\t\t\ti, index;\n\t\t\tshapeIndex = shapeIndex | 0;\n\t\t\tfor (i = 0; i < l; i++) {\n\t\t\t\tindex = (i + shapeIndex) % wrap;\n\t\t\t\tbezier[i++] = a[index];\n\t\t\t\tbezier[i] = a[index+1];\n\t\t\t}\n\t\t},\n\t\t_getTotalMovement = function(sb, eb, shapeIndex, offsetX, offsetY) {\n\t\t\tvar l = sb.length,\n\t\t\t\td = 0,\n\t\t\t\twrap = l - 2,\n\t\t\t\tindex, i, x, y;\n\t\t\tshapeIndex *= 6;\n\t\t\tfor (i = 0; i < l; i += 6) {\n\t\t\t\tindex = (i + shapeIndex) % wrap;\n\t\t\t\ty = sb[index] - (eb[i] - offsetX);\n\t\t\t\tx = sb[index+1] - (eb[i+1] - offsetY);\n\t\t\t\td += Math.sqrt(x * x + y * y);\n\t\t\t}\n\t\t\treturn d;\n\t\t},\n\t\t_getClosestShapeIndex = function(sb, eb, checkReverse) { //finds the index in a closed cubic bezier array that's closest to the angle provided (angle measured from the center or average x/y).\n\t\t\tvar l = sb.length,\n\t\t\t\tsCenter = _getAverageXY(sb), //when comparing distances, adjust the coordinates as if the shapes are centered with each other.\n\t\t\t\teCenter = _getAverageXY(eb),\n\t\t\t\toffsetX = eCenter[0] - sCenter[0],\n\t\t\t\toffsetY = eCenter[1] - sCenter[1],\n\t\t\t\tmin = _getTotalMovement(sb, eb, 0, offsetX, offsetY),\n\t\t\t\tminIndex = 0,\n\t\t\t\tcopy, d, i;\n\t\t\tfor (i = 6; i < l; i += 6) {\n\t\t\t\td = _getTotalMovement(sb, eb, i / 6, offsetX, offsetY);\n\t\t\t\tif (d < min) {\n\t\t\t\t\tmin = d;\n\t\t\t\t\tminIndex = i;\n\t\t\t\t}\n\t\t\t}\n\t\t\tif (checkReverse) {\n\t\t\t\tcopy = sb.slice(0);\n\t\t\t\t_reverseBezier(copy);\n\t\t\t\tfor (i = 6; i < l; i += 6) {\n\t\t\t\t\td = _getTotalMovement(copy, eb, i / 6, offsetX, offsetY);\n\t\t\t\t\tif (d < min) {\n\t\t\t\t\t\tmin = d;\n\t\t\t\t\t\tminIndex = -i;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\treturn minIndex / 6;\n\t\t},\n\t\t_getClosestAnchor = function(bezier, x, y) { //finds the x/y of the anchor that's closest to the provided x/y coordinate (returns an array, like [x, y]). The bezier should be the top-level type that contains an array for each segment.\n\t\t\tvar j = bezier.length,\n\t\t\t\tclosestDistance = 99999999999,\n\t\t\t\tclosestX = 0,\n\t\t\t\tclosestY = 0,\n\t\t\t\tb, dx, dy, d, i, l;\n\t\t\twhile (--j > -1) {\n\t\t\t\tb = bezier[j];\n\t\t\t\tl = b.length;\n\t\t\t\tfor (i = 0; i < l; i += 6) {\n\t\t\t\t\tdx = b[i] - x;\n\t\t\t\t\tdy = b[i+1] - y;\n\t\t\t\t\td = Math.sqrt(dx * dx + dy * dy);\n\t\t\t\t\tif (d < closestDistance) {\n\t\t\t\t\t\tclosestDistance = d;\n\t\t\t\t\t\tclosestX = b[i];\n\t\t\t\t\t\tclosestY = b[i+1];\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\treturn [closestX, closestY];\n\t\t},\n\t\t_getClosestSegment = function(bezier, pool, startIndex, sortRatio, offsetX, offsetY) { //matches the bezier to the closest one in a pool (array) of beziers, assuming they are in order of size and we shouldn't drop more than 20% of the size, otherwise prioritizing location (total distance to the center). Extracts the segment out of the pool array and returns it.\n\t\t\tvar l = pool.length,\n\t\t\t\tindex = 0,\n\t\t\t\tminSize = Math.min(bezier.size || _getSize(bezier), pool[startIndex].size || _getSize(pool[startIndex])) * sortRatio, //limit things based on a percentage of the size of either the bezier or the next element in the array, whichever is smaller.\n\t\t\t\tmin = 999999999999,\n\t\t\t\tcx = bezier.centerX + offsetX,\n\t\t\t\tcy = bezier.centerY + offsetY,\n\t\t\t\tsize, i, dx, dy, d;\n\t\t\tfor (i = startIndex; i < l; i++) {\n\t\t\t\tsize = pool[i].size || _getSize(pool[i]);\n\t\t\t\tif (size < minSize) {\n\t\t\t\t\tbreak;\n\t\t\t\t}\n\t\t\t\tdx = pool[i].centerX - cx;\n\t\t\t\tdy = pool[i].centerY - cy;\n\t\t\t\td = Math.sqrt(dx * dx + dy * dy);\n\t\t\t\tif (d < min) {\n\t\t\t\t\tindex = i;\n\t\t\t\t\tmin = d;\n\t\t\t\t}\n\t\t\t}\n\t\t\td = pool[index];\n\t\t\tpool.splice(index, 1);\n\t\t\treturn d;\n\t\t},\n\t\t_equalizeSegmentQuantity = function(start, end, shapeIndex, map) { //returns an array of shape indexes, 1 for each segment.\n\t\t\tvar dif = end.length - start.length,\n\t\t\t\tlonger = dif > 0 ? end : start,\n\t\t\t\tshorter = dif > 0 ? start : end,\n\t\t\t\tadded = 0,\n\t\t\t\tsortMethod = (map === \"complexity\") ? _sortByComplexity : _sortBySize,\n\t\t\t\tsortRatio = (map === \"position\") ? 0 : (typeof(map) === \"number\") ? map : 0.8,\n\t\t\t\ti = shorter.length,\n\t\t\t\tshapeIndices = (typeof(shapeIndex) === \"object\" && shapeIndex.push) ? shapeIndex.slice(0) : [shapeIndex],\n\t\t\t\treverse = (shapeIndices[0] === \"reverse\" || shapeIndices[0] < 0),\n\t\t\t\tlog = (shapeIndex === \"log\"),\n\t\t\t\teb, sb, b, x, y, offsetX, offsetY;\n\t\t\tif (!shorter[0]) {\n\t\t\t\treturn;\n\t\t\t}\n\t\t\tif (longer.length > 1) {\n\t\t\t\tstart.sort(sortMethod);\n\t\t\t\tend.sort(sortMethod);\n\t\t\t\toffsetX = longer.size || _getTotalSize(longer); //ensures centerX and centerY are defined (used below).\n\t\t\t\toffsetX = shorter.size || _getTotalSize(shorter);\n\t\t\t\toffsetX = longer.centerX - shorter.centerX;\n\t\t\t\toffsetY = longer.centerY - shorter.centerY;\n\t\t\t\tif (sortMethod === _sortBySize) {\n\t\t\t\t\tfor (i = 0; i < shorter.length; i++) {\n\t\t\t\t\t\tlonger.splice(i, 0, _getClosestSegment(shorter[i], longer, i, sortRatio, offsetX, offsetY));\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\tif (dif) {\n\t\t\t\tif (dif < 0) {\n\t\t\t\t\tdif = -dif;\n\t\t\t\t}\n\t\t\t\tif (longer[0].length > shorter[0].length) { //since we use shorter[0] as the one to map the origination point of any brand new fabricated segments, do any subdividing first so that there are more points to choose from (if necessary)\n\t\t\t\t\t_subdivideBezier(shorter[0], ((longer[0].length - shorter[0].length)/6) | 0);\n\t\t\t\t}\n\t\t\t\ti = shorter.length;\n\t\t\t\twhile (added < dif) {\n\t\t\t\t\tx = longer[i].size || _getSize(longer[i]); //just to ensure centerX and centerY are calculated which we use on the next line.\n\t\t\t\t\tb = _getClosestAnchor(shorter, longer[i].centerX, longer[i].centerY);\n\t\t\t\t\tx = b[0];\n\t\t\t\t\ty = b[1];\n\t\t\t\t\tshorter[i++] = [x, y, x, y, x, y, x, y];\n\t\t\t\t\tshorter.totalPoints += 8;\n\t\t\t\t\tadded++;\n\t\t\t\t}\n\t\t\t}\n\t\t\tfor (i = 0; i < start.length; i++) {\n\t\t\t\teb = end[i];\n\t\t\t\tsb = start[i];\n\t\t\t\tdif = eb.length - sb.length;\n\t\t\t\tif (dif < 0) {\n\t\t\t\t\t_subdivideBezier(eb, (-dif/6) | 0);\n\t\t\t\t} else if (dif > 0) {\n\t\t\t\t\t_subdivideBezier(sb, (dif/6) | 0);\n\t\t\t\t}\n\t\t\t\tif (reverse && !sb.reversed) {\n\t\t\t\t\t_reverseBezier(sb);\n\t\t\t\t}\n\t\t\t\tshapeIndex = (shapeIndices[i] || shapeIndices[i] === 0) ? shapeIndices[i] : \"auto\";\n\t\t\t\tif (shapeIndex) {\n\t\t\t\t\t//if start shape is closed, find the closest point to the start/end, and re-organize the bezier points accordingly so that the shape morphs in a more intuitive way.\n\t\t\t\t\tif (sb.closed || (Math.abs(sb[0] - sb[sb.length - 2]) < 0.5 && Math.abs(sb[1] - sb[sb.length - 1]) < 0.5)) {\n\t\t\t\t\t\tif (shapeIndex === \"auto\" || shapeIndex === \"log\") {\n\t\t\t\t\t\t\tshapeIndices[i] = shapeIndex = _getClosestShapeIndex(sb, eb, i === 0);\n\t\t\t\t\t\t\tif (shapeIndex < 0) {\n\t\t\t\t\t\t\t\treverse = true;\n\t\t\t\t\t\t\t\t_reverseBezier(sb);\n\t\t\t\t\t\t\t\tshapeIndex = -shapeIndex;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t_offsetBezier(sb, shapeIndex * 6);\n\n\t\t\t\t\t\t} else if (shapeIndex !== \"reverse\") {\n\t\t\t\t\t\t\tif (i && shapeIndex < 0) { //only happens if an array is passed as shapeIndex and a negative value is defined for an index beyond 0. Very rare, but helpful sometimes.\n\t\t\t\t\t\t\t\t_reverseBezier(sb);\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t_offsetBezier(sb, (shapeIndex < 0 ? -shapeIndex : shapeIndex) * 6);\n\t\t\t\t\t\t}\n\t\t\t\t\t//otherwise, if it's not a closed shape, consider reversing it if that would make the overall travel less\n\t\t\t\t\t} else if (!reverse && (shapeIndex === \"auto\" && (Math.abs(eb[0] - sb[0]) + Math.abs(eb[1] - sb[1]) + Math.abs(eb[eb.length - 2] - sb[sb.length - 2]) + Math.abs(eb[eb.length - 1] - sb[sb.length - 1]) > Math.abs(eb[0] - sb[sb.length - 2]) + Math.abs(eb[1] - sb[sb.length - 1]) + Math.abs(eb[eb.length - 2] - sb[0]) + Math.abs(eb[eb.length - 1] - sb[1])) || (shapeIndex % 2))) {\n\t\t\t\t\t\t_reverseBezier(sb);\n\t\t\t\t\t\tshapeIndices[i] = -1;\n\t\t\t\t\t\treverse = true;\n\t\t\t\t\t} else if (shapeIndex === \"auto\") {\n\t\t\t\t\t\tshapeIndices[i] = 0;\n\t\t\t\t\t} else if (shapeIndex === \"reverse\") {\n\t\t\t\t\t\tshapeIndices[i] = -1;\n\t\t\t\t\t}\n\t\t\t\t\tif (sb.closed !== eb.closed) { //if one is closed and one isn't, don't close either one otherwise the tweening will look weird (but remember, the beginning and final states will honor the actual values, so this only affects the inbetween state)\n\t\t\t\t\t\tsb.closed = eb.closed = false;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\tif (log) {\n\t\t\t\t_log(\"shapeIndex:[\" + shapeIndices.join(\",\") + \"]\");\n\t\t\t}\n\t\t\treturn shapeIndices;\n\t\t},\n\t\t_pathFilter = function(a, shapeIndex, map, precompile) {\n\t\t\tvar start = _pathDataToBezier(a[0]),\n\t\t\t\tend = _pathDataToBezier(a[1]);\n\t\t\tif (!_equalizeSegmentQuantity(start, end, (shapeIndex || shapeIndex === 0) ? shapeIndex : \"auto\", map)) {\n\t\t\t\treturn; //malformed path data or null target\n\t\t\t}\n\t\t\ta[0] = _bezierToPathData(start);\n\t\t\ta[1] = _bezierToPathData(end);\n\t\t\tif (precompile === \"log\" || precompile === true) {\n\t\t\t\t_log('precompile:[\"' + a[0] + '\",\"' + a[1] + '\"]');\n\t\t\t}\n\t\t},\n\t\t_buildPathFilter = function(shapeIndex, map, precompile) {\n\t\t\treturn (map || precompile || shapeIndex || shapeIndex === 0) ? function(a) {\n\t\t\t\t_pathFilter(a, shapeIndex, map, precompile);\n\t\t\t} : _pathFilter;\n\t\t},\n\t\t_offsetPoints = function(text, offset) {\n\t\t\tif (!offset) {\n\t\t\t\treturn text;\n\t\t\t}\n\t\t\tvar a = text.match(_numbersExp) || [],\n\t\t\t\tl = a.length,\n\t\t\t\ts = \"\",\n\t\t\t\tinc, i, j;\n\t\t\tif (offset === \"reverse\") {\n\t\t\t\ti = l-1;\n\t\t\t\tinc = -2;\n\t\t\t} else {\n\t\t\t\ti = (((parseInt(offset, 10) || 0) * 2 + 1) + l * 100) % l;\n\t\t\t\tinc = 2;\n\t\t\t}\n\t\t\tfor (j = 0; j < l; j += 2) {\n\t\t\t\ts += a[i-1] + \",\" + a[i] + \" \";\n\t\t\t\ti = (i + inc) % l;\n\t\t\t}\n\t\t\treturn s;\n\t\t},\n\t\t//adds a certain number of points while maintaining the polygon/polyline shape (so that the start/end values can have a matching quantity of points to animate). Returns the revised string.\n\t\t_equalizePointQuantity = function(a, quantity) {\n\t\t\tvar tally = 0,\n\t\t\t\tx = parseFloat(a[0]),\n\t\t\t\ty = parseFloat(a[1]),\n\t\t\t\ts = x + \",\" + y + \" \",\n\t\t\t\tmax = 0.999999,\n\t\t\t\tnewPointsPerSegment, i, l, j, factor, nextX, nextY;\n\t\t\tl = a.length;\n\t\t\tnewPointsPerSegment = quantity * 0.5 / (l * 0.5 - 1);\n\t\t\tfor (i = 0; i < l-2; i += 2) {\n\t\t\t\ttally += newPointsPerSegment;\n\t\t\t\tnextX = parseFloat(a[i+2]);\n\t\t\t\tnextY = parseFloat(a[i+3]);\n\t\t\t\tif (tally > max) { //compare with 0.99999 instead of 1 in order to prevent rounding errors\n\t\t\t\t\tfactor = 1 / (Math.floor(tally) + 1);\n\t\t\t\t\tj = 1;\n\t\t\t\t\twhile (tally > max) {\n\t\t\t\t\t\ts += (x + (nextX - x) * factor * j).toFixed(2) + \",\" + (y + (nextY - y) * factor * j).toFixed(2) + \" \";\n\t\t\t\t\t\ttally--;\n\t\t\t\t\t\tj++;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\ts += nextX + \",\" + nextY + \" \";\n\t\t\t\tx = nextX;\n\t\t\t\ty = nextY;\n\t\t\t}\n\t\t\treturn s;\n\t\t},\n\t\t_pointsFilter = function(a) {\n\t\t\tvar startNums = a[0].match(_numbersExp) || [],\n\t\t\t\tendNums = a[1].match(_numbersExp) || [],\n\t\t\t\tdif = endNums.length - startNums.length;\n\t\t\tif (dif > 0) {\n\t\t\t\ta[0] = _equalizePointQuantity(startNums, dif);\n\t\t\t} else {\n\t\t\t\ta[1] = _equalizePointQuantity(endNums, -dif);\n\t\t\t}\n\t\t},\n\t\t_buildPointsFilter = function(shapeIndex) {\n\t\t\treturn !isNaN(shapeIndex) ? function(a) {\n\t\t\t\t_pointsFilter(a);\n\t\t\t\ta[1] = _offsetPoints(a[1], parseInt(shapeIndex, 10));\n\t\t\t} : _pointsFilter;\n\t\t},\n\t\t_createPath = function(e, ignore) {\n\t\t\tvar path = _gsScope.document.createElementNS(\"http://www.w3.org/2000/svg\", \"path\"),\n\t\t\t\tattr = Array.prototype.slice.call(e.attributes),\n\t\t\t\ti = attr.length,\n\t\t\t\tname;\n\t\t\tignore = \",\" + ignore + \",\";\n\t\t\twhile (--i > -1) {\n\t\t\t\tname = attr[i].nodeName.toLowerCase(); //in Microsoft Edge, if you don't set the attribute with a lowercase name, it doesn't render correctly! Super weird.\n\t\t\t\tif (ignore.indexOf(\",\" + name + \",\") === -1) {\n\t\t\t\t\tpath.setAttributeNS(null, name, attr[i].nodeValue);\n\t\t\t\t}\n\t\t\t}\n\t\t\treturn path;\n\t\t},\n\t\t_convertToPath = function(e, swap) {\n\t\t\tvar type = e.tagName.toLowerCase(),\n\t\t\t\tcirc = 0.552284749831,\n\t\t\t\tdata, x, y, r, ry, path, rcirc, rycirc, points, w, h, x2, x3, x4, x5, x6, y2, y3, y4, y5, y6;\n\t\t\tif (type === \"path\" || !e.getBBox) {\n\t\t\t\treturn e;\n\t\t\t}\n\t\t\tpath = _createPath(e, \"x,y,width,height,cx,cy,rx,ry,r,x1,x2,y1,y2,points\");\n\t\t\tif (type === \"rect\") {\n\t\t\t\tr = +e.getAttribute(\"rx\") || 0;\n\t\t\t\try = +e.getAttribute(\"ry\") || 0;\n\t\t\t\tx = +e.getAttribute(\"x\") || 0;\n\t\t\t\ty = +e.getAttribute(\"y\") || 0;\n\t\t\t\tw = (+e.getAttribute(\"width\") || 0) - r * 2;\n\t\t\t\th = (+e.getAttribute(\"height\") || 0) - ry * 2;\n\t\t\t\tif (r || ry) { //if there are rounded corners, render cubic beziers\n\t\t\t\t\tx2 = x + r * (1 - circ);\n\t\t\t\t\tx3 = x + r;\n\t\t\t\t\tx4 = x3 + w;\n\t\t\t\t\tx5 = x4 + r * circ;\n\t\t\t\t\tx6 = x4 + r;\n\t\t\t\t\ty2 = y + ry * (1 - circ);\n\t\t\t\t\ty3 = y + ry;\n\t\t\t\t\ty4 = y3 + h;\n\t\t\t\t\ty5 = y4 + ry * circ;\n\t\t\t\t\ty6 = y4 + ry;\n\t\t\t\t\tdata = \"M\" + x6 + \",\" + y3 + \" V\" + y4 + \" C\" + [x6, y5, x5, y6, x4, y6, x4 - (x4 - x3) / 3, y6, x3 + (x4 - x3) / 3, y6, x3, y6, x2, y6, x, y5, x, y4, x, y4 - (y4 - y3) / 3, x, y3 + (y4 - y3) / 3, x, y3, x, y2, x2, y, x3, y, x3 + (x4 - x3) / 3, y, x4 - (x4 - x3) / 3, y, x4, y, x5, y, x6, y2, x6, y3].join(\",\") + \"z\";\n\t\t\t\t} else {\n\t\t\t\t\tdata = \"M\" + (x + w) + \",\" + y + \" v\" + h + \" h\" + (-w) + \" v\" + (-h) + \" h\" + w + \"z\";\n\t\t\t\t}\n\n\t\t\t} else if (type === \"circle\" || type === \"ellipse\") {\n\t\t\t\tif (type === \"circle\") {\n\t\t\t\t\tr = ry = +e.getAttribute(\"r\") || 0;\n\t\t\t\t\trycirc = r * circ;\n\t\t\t\t} else {\n\t\t\t\t\tr = +e.getAttribute(\"rx\") || 0;\n\t\t\t\t\try = +e.getAttribute(\"ry\") || 0;\n\t\t\t\t\trycirc = ry * circ;\n\t\t\t\t}\n\t\t\t\tx = +e.getAttribute(\"cx\") || 0;\n\t\t\t\ty = +e.getAttribute(\"cy\") || 0;\n\t\t\t\trcirc = r * circ;\n\t\t\t\tdata = \"M\" + (x+r) + \",\" + y + \" C\" + [x+r, y + rycirc, x + rcirc, y + ry, x, y + ry, x - rcirc, y + ry, x - r, y + rycirc, x - r, y, x - r, y - rycirc, x - rcirc, y - ry, x, y - ry, x + rcirc, y - ry, x + r, y - rycirc, x + r, y].join(\",\") + \"z\";\n\t\t\t} else if (type === \"line\") {\n\t\t\t\tdata = \"M\" + (e.getAttribute(\"x1\") || 0) + \",\" + (e.getAttribute(\"y1\") || 0) + \" L\" + (e.getAttribute(\"x2\") || 0) + \",\" + (e.getAttribute(\"y2\") || 0);\n\t\t\t} else if (type === \"polyline\" || type === \"polygon\") {\n\t\t\t\tpoints = (e.getAttribute(\"points\") + \"\").match(_numbersExp) || [];\n\t\t\t\tx = points.shift();\n\t\t\t\ty = points.shift();\n\t\t\t\tdata = \"M\" + x + \",\" + y + \" L\" + points.join(\",\");\n\t\t\t\tif (type === \"polygon\") {\n\t\t\t\t\tdata += \",\" + x + \",\" + y + \"z\";\n\t\t\t\t}\n\t\t\t}\n\t\t\tpath.setAttribute(\"d\", data);\n\t\t\tif (swap && e.parentNode) {\n\t\t\t\te.parentNode.insertBefore(path, e);\n\t\t\t\te.parentNode.removeChild(e);\n\t\t\t}\n\n\t\t\treturn path;\n\t\t},\n\t\t_parseShape = function(shape, forcePath, target) {\n\t\t\tvar isString = typeof(shape) === \"string\",\n\t\t\t\te, type;\n\t\t\tif (!isString || _selectorExp.test(shape) || (shape.match(_numbersExp) || []).length < 3) {\n\t\t\t\te = isString ? TweenLite.selector(shape) : (shape && shape[0]) ? shape : [shape]; //allow array-like objects like jQuery objects.\n\t\t\t\tif (e && e[0]) {\n\t\t\t\t\te = e[0];\n\t\t\t\t\ttype = e.nodeName.toUpperCase();\n\t\t\t\t\tif (forcePath && type !== \"PATH\") { //if we were passed an element (or selector text for an element) that isn't a path, convert it.\n\t\t\t\t\t\te = _convertToPath(e, false);\n\t\t\t\t\t\ttype = \"PATH\";\n\t\t\t\t\t}\n\t\t\t\t\tshape = e.getAttribute(type === \"PATH\" ? \"d\" : \"points\") || \"\";\n\t\t\t\t\tif (e === target) { //if the shape matches the target element, the user wants to revert to the original which should have been stored in the data-original attribute\n\t\t\t\t\t\tshape = e.getAttributeNS(null, \"data-original\") || shape;\n\t\t\t\t\t}\n\t\t\t\t} else {\n\t\t\t\t\t_log(\"WARNING: invalid morph to: \" + shape);\n\t\t\t\t\tshape = false;\n\t\t\t\t}\n\t\t\t}\n\t\t\treturn shape;\n\t\t},\n\t\t_morphMessage = \"Use MorphSVGPlugin.convertToPath(elementOrSelectorText) to convert to a path before morphing.\",\n\n\n\n\t\tMorphSVGPlugin = _gsScope._gsDefine.plugin({\n\t\t\tpropName: \"morphSVG\",\n\t\t\tAPI: 2,\n\t\t\tglobal: true,\n\t\t\tversion: \"0.8.11\",\n\n\t\t\t//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.\n\t\t\tinit: function(target, value, tween, index) {\n\t\t\t\tvar type, p, pt, shape, isPoly;\n\t\t\t\tif (typeof(target.setAttribute) !== \"function\") {\n\t\t\t\t\treturn false;\n\t\t\t\t}\n\t\t\t\tif (typeof(value) === \"function\") {\n\t\t\t\t\tvalue = value(index, target);\n\t\t\t\t}\n\t\t\t\ttype = target.nodeName.toUpperCase();\n\t\t\t\tisPoly = (type === \"POLYLINE\" || type === \"POLYGON\");\n\t\t\t\tif (type !== \"PATH\" && !isPoly) {\n\t\t\t\t\t_log(\"WARNING: cannot morph a <\" + type + \"> SVG element. \" + _morphMessage);\n\t\t\t\t\treturn false;\n\t\t\t\t}\n\t\t\t\tp = (type === \"PATH\") ? \"d\" : \"points\";\n\t\t\t\tif (typeof(value) === \"string\" || value.getBBox || value[0]) {\n\t\t\t\t\tvalue = {shape:value};\n\t\t\t\t}\n\t\t\t\tshape = _parseShape(value.shape || value.d || value.points || \"\", (p === \"d\"), target);\n\t\t\t\tif (isPoly && _commands.test(shape)) {\n\t\t\t\t\t_log(\"WARNING: a <\" + type + \"> cannot accept path data. \" + _morphMessage);\n\t\t\t\t\treturn false;\n\t\t\t\t}\n\t\t\t\tif (shape) {\n\t\t\t\t\tthis._target = target;\n\t\t\t\t\tif (!target.getAttributeNS(null, \"data-original\")) {\n\t\t\t\t\t\ttarget.setAttributeNS(null, \"data-original\", target.getAttribute(p)); //record the original state in a data-original attribute so that we can revert to it later.\n\t\t\t\t\t}\n\t\t\t\t\tpt = this._addTween(target, \"setAttribute\", target.getAttribute(p) + \"\", shape + \"\", \"morphSVG\", false, p, (typeof(value.precompile) === \"object\") ? function(a) {a[0] = value.precompile[0]; a[1] = value.precompile[1];} : (p === \"d\") ? _buildPathFilter(value.shapeIndex, value.map || MorphSVGPlugin.defaultMap, value.precompile) : _buildPointsFilter(value.shapeIndex));\n\t\t\t\t\tif (pt) {\n\t\t\t\t\t\tthis._overwriteProps.push(\"morphSVG\");\n\t\t\t\t\t\tpt.end = shape;\n\t\t\t\t\t\tpt.endProp = p;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\treturn true;\n\t\t\t},\n\n\t\t\tset: function(ratio) {\n\t\t\t\tvar pt;\n\t\t\t\tthis._super.setRatio.call(this, ratio);\n\t\t\t\tif (ratio === 1) {\n\t\t\t\t\tpt = this._firstPT;\n\t\t\t\t\twhile (pt) {\n\t\t\t\t\t\tif (pt.end) {\n\t\t\t\t\t\t\tthis._target.setAttribute(pt.endProp, pt.end); //make sure the end value is exactly as specified (in case we had to add fabricated points during the tween)\n\t\t\t\t\t\t}\n\t\t\t\t\t\tpt = pt._next;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t});\n\n\tMorphSVGPlugin.pathFilter = _pathFilter;\n\tMorphSVGPlugin.pointsFilter = _pointsFilter;\n\tMorphSVGPlugin.subdivideRawBezier = _subdivideBezier;\n\tMorphSVGPlugin.defaultMap = \"size\";\n\tMorphSVGPlugin.pathDataToRawBezier = function(data) {\n\t\treturn _pathDataToBezier(_parseShape(data, true));\n\t};\n\tMorphSVGPlugin.equalizeSegmentQuantity = _equalizeSegmentQuantity;\n\n\tMorphSVGPlugin.convertToPath = function(targets, swap) {\n\t\tif (typeof(targets) === \"string\") {\n\t\t\ttargets = TweenLite.selector(targets);\n\t\t}\n\t\tvar a = (!targets || targets.length === 0) ? [] : (targets.length && targets[0] && targets[0].nodeType) ? Array.prototype.slice.call(targets, 0) : [targets],\n\t\t\ti = a.length;\n\t\twhile (--i > -1) {\n\t\t\ta[i] = _convertToPath(a[i], (swap !== false));\n\t\t}\n\t\treturn a;\n\t};\n\n\tMorphSVGPlugin.pathDataToBezier = function(data, vars) { //converts SVG path data into an array of {x, y} objects that can be plugged directly into a bezier tween. You can optionally pass in a 2D matrix like [a, b, c, d, tx, ty] containing numbers that should transform each point.\n\t\tvar bezier = _pathDataToBezier(_parseShape(data, true))[0] || [],\n\t\t\tprefix = 0,\n\t\t\ta, i, l, matrix, offsetX, offsetY, bbox, e;\n\t\tvars = vars || {};\n\t\te = vars.align || vars.relative;\n\t\tmatrix = vars.matrix || [1,0,0,1,0,0];\n\t\toffsetX = vars.offsetX || 0;\n\t\toffsetY = vars.offsetY || 0;\n\t\tif (e === \"relative\" || e === true) {\n\t\t\toffsetX -= bezier[0] * matrix[0] + bezier[1] * matrix[2];\n\t\t\toffsetY -= bezier[0] * matrix[1] + bezier[1] * matrix[3];\n\t\t\tprefix = \"+=\";\n\t\t} else {\n\t\t\toffsetX += matrix[4];\n\t\t\toffsetY += matrix[5];\n\t\t\tif (e) {\n\t\t\t\te = (typeof(e) === \"string\") ? TweenLite.selector(e) : (e && e[0]) ? e : [e]; //allow array-like objects like jQuery objects.\n\t\t\t\tif (e && e[0]) {\n\t\t\t\t\tbbox = e[0].getBBox() || {x:0, y:0};\n\t\t\t\t\toffsetX -= bbox.x;\n\t\t\t\t\toffsetY -= bbox.y;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\ta = [];\n\t\tl = bezier.length;\n\t\tif (matrix && matrix.join(\",\") !== \"1,0,0,1,0,0\") {\n\t\t\tfor (i = 0; i < l; i+=2) {\n\t\t\t\ta.push({x:prefix + (bezier[i] * matrix[0] + bezier[i+1] * matrix[2] + offsetX), y:prefix + (bezier[i] * matrix[1] + bezier[i+1] * matrix[3] + offsetY)});\n\t\t\t}\n\t\t} else {\n\t\t\tfor (i = 0; i < l; i+=2) {\n\t\t\t\ta.push({x:prefix + (bezier[i] + offsetX), y:prefix + (bezier[i+1] + offsetY)});\n\t\t\t}\n\t\t}\n\t\treturn a;\n\t};\n\n\n\n}); if (_gsScope._gsDefine) { _gsScope._gsQueue.pop()(); }\n//export to AMD/RequireJS and CommonJS/Node (precursor to full modular build system coming at a later date)\n(function(name) {\n\t\"use strict\";\n\tvar getGlobal = function() {\n\t\treturn (_gsScope.GreenSockGlobals || _gsScope)[name];\n\t};\n\tif (typeof(module) !== \"undefined\" && module.exports) { //node\n\t\trequire(\"gsap/TweenLite\");\n\t\tmodule.exports = getGlobal();\n\t} else if (typeof(define) === \"function\" && define.amd) { //AMD\n\t\tdefine([\"gsap/TweenLite\"], getGlobal);\n\t}\n}(\"MorphSVGPlugin\"));"

/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(397)(__webpack_require__(396))

/***/ }),

/***/ 400:
/***/ (function(module, exports) {

module.exports = "<svg id=\"__1Dm1det__57668381-733c-408b-b15b-91332ee24394\" data-name=\"About\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\"><title>donauhof</title><path d=\"M18,34V5.51m-7.07,7.14H25.07M3.87,19.75a14.13,14.13,0,1,0,28.26,0M18,2a1.78,1.78,0,1,0,1.77,1.78A1.77,1.77,0,0,0,18,2ZM7.48,22.77l-3.61-3-3,3.63m34.3,0-3-3.63-3.61,3\" style=\"fill:none;stroke:#da9533;stroke-miterlimit:10\"></path></svg>"

/***/ }),

/***/ 401:
/***/ (function(module, exports) {

module.exports = "<svg id=\"__1Dm1det__924f9761-2c84-412f-be11-72494c3493cc\" data-name=\"Ballsaal\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\"><title>donauhof</title><path d=\"M18,10.5a2,2,0,1,1,2-2A2,2,0,0,1,18,10.5Zm17,7a2,2,0,1,0-2,2A2,2,0,0,0,35,17.5Zm-7-2a2,2,0,1,0-2,2A2,2,0,0,0,28,15.5Zm-8,12a2,2,0,1,0-2,2A2,2,0,0,0,20,27.5Zm2-6a4,4,0,1,0-4,4A4,4,0,0,0,22,21.5Zm-4-4v-7M21,24C24,26,25.65,22.58,26,17.5c0,0,.54,8,3.5,8s3.5-6,3.5-6m-30,0a2,2,0,1,0-2-2A2,2,0,0,0,3,19.5Zm7-2a2,2,0,1,0-2-2A2,2,0,0,0,10,17.5Zm-7,2s.54,6,3.5,6,3.5-8,3.5-8c.35,5.08,2,8.49,5,6.55\" style=\"fill:none;stroke:#da9533;stroke-miterlimit:10\"></path></svg>"

/***/ }),

/***/ 402:
/***/ (function(module, exports) {

module.exports = "<svg id=\"__1Dm1det__cda88051-f769-4460-8ba3-168521fafddc\" data-name=\"Cafe\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\"><title>donauhof</title><path d=\"M25.51,12.31v11h0A11.43,11.43,0,0,1,14.32,35,11.43,11.43,0,0,1,3.12,23.31h0v-11Zm0,11.33h3.58a3.73,3.73,0,1,0,0-7.45H25.49ZM12,8.13a2.55,2.55,0,0,0,0-3.84A2.22,2.22,0,0,1,12,1m4.71,7.15a2.55,2.55,0,0,0,0-3.84,2.22,2.22,0,0,1,0-3.31\" style=\"fill:none;stroke:#da9533;stroke-miterlimit:10\"></path></svg>"

/***/ }),

/***/ 403:
/***/ (function(module, exports) {

module.exports = "<svg id=\"__1Dm1det__69037c50-83ee-45fb-99d1-318e40b9ec58\" data-name=\"Ebene 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\"><title>donauhof</title><path d=\"M33,27H3V6.58H33Zm2.5,0H.5v2.5h35ZM18,18.5a.5.5,0,1,0,.5.5A.5.5,0,0,0,18,18.5Zm4.6-4.09a6.48,6.48,0,0,0-4.46-1.9h-.28a6.48,6.48,0,0,0-4.46,1.9m7.78,1.41a4.5,4.5,0,0,0-6.37,0m5,1.41a2.5,2.5,0,0,0-3.54,0\" style=\"fill:none;stroke:#da9533;stroke-miterlimit:10\"></path></svg>"

/***/ }),

/***/ 404:
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 307.03 27.39\"><title>Logo Full</title><path d=\"M22.85,13.7a14.17,14.17,0,0,0-1-5.48,13,13,0,0,0-2.88-4.32A13.39,13.39,0,0,0,14.6,1,14.07,14.07,0,0,0,9.16,0H0V27.39H9.16a14.07,14.07,0,0,0,5.44-1,13.37,13.37,0,0,0,4.34-2.86,13,13,0,0,0,2.88-4.32A14.18,14.18,0,0,0,22.85,13.7Zm-3.35,4.48A10.47,10.47,0,0,1,13.64,24a11.72,11.72,0,0,1-4.48.84H2.5V2.5H9.16a11.72,11.72,0,0,1,4.48.84,10.47,10.47,0,0,1,5.87,5.87,11.72,11.72,0,0,1,.84,4.48A11.72,11.72,0,0,1,19.51,18.18Z\" style=\"fill:#333\"></path><path d=\"M62.4,3.91A13,13,0,0,0,58.05,1a14.22,14.22,0,0,0-5.46-1,14.07,14.07,0,0,0-5.44,1,13.08,13.08,0,0,0-7.22,7.22,14.07,14.07,0,0,0-1,5.44,14.07,14.07,0,0,0,1,5.44,13.08,13.08,0,0,0,7.22,7.22,14.07,14.07,0,0,0,5.44,1,14.22,14.22,0,0,0,5.46-1,13,13,0,0,0,4.34-2.88,13.38,13.38,0,0,0,2.86-4.34,14.07,14.07,0,0,0,1-5.44,14.07,14.07,0,0,0-1-5.44A13.38,13.38,0,0,0,62.4,3.91Zm.55,14.26A10.47,10.47,0,0,1,57.07,24a12.36,12.36,0,0,1-9,0,10.47,10.47,0,0,1-5.87-5.87,11.72,11.72,0,0,1-.84-4.48,11.72,11.72,0,0,1,.84-4.48,10.47,10.47,0,0,1,5.87-5.87,12.36,12.36,0,0,1,9,0,10.47,10.47,0,0,1,5.87,5.87,11.72,11.72,0,0,1,.84,4.48A11.72,11.72,0,0,1,62.94,18.18Z\" style=\"fill:#333\"></path><polygon points=\"104.8 23.4 85.35 0 82.84 0 82.84 27.39 85.35 27.39 85.35 4.03 104.8 27.39 107.3 27.39 107.3 0 104.8 0 104.8 23.4\" style=\"fill:#333\"></polygon><path d=\"M135.44,0,122.68,27.39h2.74l2.31-5h18l2.31,5h2.78L138.06,0ZM128.9,19.88,136.73,3l7.83,16.87Z\" style=\"fill:#333\"></path><path d=\"M186.58,15a9.93,9.93,0,0,1-.76,3.91,9.62,9.62,0,0,1-5.24,5.22,10.67,10.67,0,0,1-7.92,0A9.65,9.65,0,0,1,169.48,22a9.78,9.78,0,0,1-2.09-3.13,9.93,9.93,0,0,1-.76-3.91V0h-2.5V15a12.54,12.54,0,0,0,1,4.93,12.07,12.07,0,0,0,2.64,3.93,12.21,12.21,0,0,0,4,2.6,12.78,12.78,0,0,0,4.93.94,12.93,12.93,0,0,0,5-.94,11.93,11.93,0,0,0,4-2.6,12.2,12.2,0,0,0,2.62-3.93,12.54,12.54,0,0,0,1-4.93V0h-2.5Z\" style=\"fill:#333\"></path><polygon points=\"227.12 12.44 209.59 12.44 209.59 0 207.09 0 207.09 27.39 209.59 27.39 209.59 14.95 227.12 14.95 227.12 27.39 229.63 27.39 229.63 0 227.12 0 227.12 12.44\" style=\"fill:#333\"></polygon><path d=\"M270,3.91A13,13,0,0,0,265.61,1a14.22,14.22,0,0,0-5.46-1,14.07,14.07,0,0,0-5.44,1,13.08,13.08,0,0,0-7.22,7.22,14.07,14.07,0,0,0-1,5.44,14.07,14.07,0,0,0,1,5.44,13.08,13.08,0,0,0,7.22,7.22,14.07,14.07,0,0,0,5.44,1,14.22,14.22,0,0,0,5.46-1A13,13,0,0,0,270,23.48a13.38,13.38,0,0,0,2.86-4.34,14.07,14.07,0,0,0,1-5.44,14.07,14.07,0,0,0-1-5.44A13.38,13.38,0,0,0,270,3.91Zm.55,14.26A10.47,10.47,0,0,1,264.63,24a12.36,12.36,0,0,1-9,0,10.47,10.47,0,0,1-5.87-5.87A11.72,11.72,0,0,1,249,13.7a11.72,11.72,0,0,1,.84-4.48,10.47,10.47,0,0,1,5.87-5.87,12.36,12.36,0,0,1,9,0,10.47,10.47,0,0,1,5.87,5.87,11.72,11.72,0,0,1,.84,4.48A11.72,11.72,0,0,1,270.5,18.18Z\" style=\"fill:#333\"></path><polygon points=\"307.03 12.44 293.18 12.44 293.18 2.5 307.03 2.5 307.03 0 290.68 0 290.68 27.39 293.18 27.39 293.18 14.95 307.03 14.95 307.03 12.44\" style=\"fill:#333\"></polygon></svg>"

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(383)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(425),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(382)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(424),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(389)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(432),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(391)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(434),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(380)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(422),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(426),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 415:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(419),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(388)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(431),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(436),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(385)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(428),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 419:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default", [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 420:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kaffeehaus"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.headline)
    }
  }), _c('seperator'), _c('div', {
    staticClass: "body"
  }, [_vm._l((_vm.body), function(paragraph) {
    return _c('p', {
      domProps: {
        "innerHTML": _vm._s(paragraph)
      }
    })
  }), _c('form', {
    attrs: {
      "action": "http://donauhofwien.at/mailchimp.php",
      "method": "put"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitForm($event)
      }
    }
  }, [_c('label', {
    staticClass: "name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Name",
      "value": "",
      "name": "NAME",
      "required": "required",
      "disabled": _vm.form.response
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  })]), _c('label', {
    staticClass: "email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.email),
      expression: "form.email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "Email Adresse",
      "value": "",
      "name": "EMAIL",
      "disabled": _vm.form.response
    },
    domProps: {
      "value": (_vm.form.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "email", $event.target.value)
      }
    }
  })]), _c('button', {
    staticClass: "cta",
    attrs: {
      "type": "submit",
      "disabled": _vm.form.response
    }
  }, [_vm._v("Anmelden")])]), (_vm.form.response) ? _c('transition', {
    attrs: {
      "name": "response",
      "mode": "out-in",
      "appear": "appear"
    }
  }, [_c('p', {
    key: _vm.form.response,
    staticClass: "response",
    domProps: {
      "innerHTML": _vm._s(_vm.form.response)
    }
  })]) : _vm._e()], 2), _c('div', {
    staticClass: "clear"
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 421:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.headline)
    }
  }), _c('seperator'), _c('div', {
    staticClass: "body"
  }, _vm._l((_vm.body), function(paragraph) {
    return _c('p', {
      domProps: {
        "innerHTML": _vm._s(paragraph)
      }
    })
  })), _c('div', {
    staticClass: "clear"
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 422:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [_c('div', {
    staticClass: "shape"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 800 70",
      "preserveAspectRatio": "none"
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "#ffffff"
    },
    attrs: {
      "d": "M800,60c0,0-58-11-162-11c-164,0-227,21-403,21C102,70,0,60,0,60V0.2h800V60z"
    }
  })])]), _c('ul', [_c('li', {
    staticClass: "mobile"
  }, [_c('router-link', {
    attrs: {
      "to": "/",
      "exact": "exact",
      "data-title": "Home"
    }
  }, [_vm._v("Home")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/ballsaal",
      "exact": "exact",
      "data-title": "Ballsaal"
    },
    nativeOn: {
      "mouseenter": function($event) {
        _vm.linkHover($event)
      }
    }
  }, [_vm._v("Ballsaal")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/co-working",
      "exact": "exact",
      "data-title": "Co-Working"
    },
    nativeOn: {
      "mouseenter": function($event) {
        _vm.linkHover($event)
      }
    }
  }, [_vm._v("Co-Working")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/kaffeehaus",
      "exact": "exact",
      "data-title": "Kaffeehaus"
    },
    nativeOn: {
      "mouseenter": function($event) {
        _vm.linkHover($event)
      }
    }
  }, [_vm._v("Kaffeehaus")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/hof",
      "exact": "exact",
      "data-title": "Der Hof"
    },
    nativeOn: {
      "mouseenter": function($event) {
        _vm.linkHover($event)
      }
    }
  }, [_vm._v("Der Hof")])], 1), _c('li', {
    staticClass: "mobile"
  }, [_c('router-link', {
    attrs: {
      "to": "/kontakt",
      "exact": "exact",
      "data-title": "Kontakt"
    }
  }, [_vm._v("Kontakt")])], 1)]), _c('div', {
    staticClass: "clear"
  })])
},staticRenderFns: []}

/***/ }),

/***/ 423:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sep",
    domProps: {
      "innerHTML": _vm._s(_vm.wave)
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 424:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('transition', {
    attrs: {
      "name": "logo",
      "mode": "out-in",
      "appear": "appear"
    }
  }, [_c('div', {
    staticClass: "logo",
    class: {
      hover: _vm.revealHeader
    },
    on: {
      "click": _vm.toggleNav,
      "mouseenter": _vm.toggleNavHover,
      "mouseleave": _vm.toggleNavHover
    }
  }, [_c('div', {
    staticClass: "logo-ctn",
    domProps: {
      "innerHTML": _vm._s(_vm.logo)
    }
  }), _c('span', [_vm._v("Menu")])])]), _c('div', {
    staticClass: "indicator"
  }, [_c('router-link', {
    class: {
      hover: _vm.revealHeader
    },
    attrs: {
      "to": "/"
    },
    nativeOn: {
      "mouseenter": function($event) {
        _vm.headerMouseover($event)
      },
      "mouseleave": function($event) {
        _vm.headerMouseover($event)
      }
    }
  }, [(_vm.indicator !== null) ? _c('transition', {
    attrs: {
      "name": "indicator",
      "css": false,
      "mode": "out-in",
      "appear": "appear"
    },
    on: {
      "enter": _vm.indicatorEnter
    }
  }, [_c('div', {
    key: _vm.indicator,
    staticClass: "icon-wrap"
  })]) : _vm._e(), _c('div', {
    staticClass: "icon",
    domProps: {
      "innerHTML": _vm._s(_vm.icon)
    }
  }), _c('span', {
    staticClass: "home-link"
  }, [_vm._v("Home")])], 1)], 1), _c('transition', {
    attrs: {
      "name": "coordinates",
      "css": false,
      "mode": "out-in",
      "appear": "appear"
    },
    on: {
      "before-enter": _vm.coordinatesBeforeEnter,
      "enter": _vm.coordinatesEnter
    }
  }, [_c('div', {
    staticClass: "coordinates"
  }, [_c('router-link', {
    class: {
      hover: _vm.revealHeader
    },
    attrs: {
      "to": "/kontakt"
    },
    nativeOn: {
      "mouseenter": function($event) {
        _vm.headerMouseover($event)
      },
      "mouseleave": function($event) {
        _vm.headerMouseover($event)
      }
    }
  }, [_c('span', [_vm._v("48° 12' 30 N"), _c('br'), _vm._v("16° 22' 19 "), _c('span', [_vm._v("E")])]), _c('span', {
    staticClass: "contact-link"
  }, [_vm._v("Kontakt")])]), _c('router-link', {
    staticClass: "icon",
    attrs: {
      "to": "/kontakt"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.contact)
    }
  })], 1)]), _c('div', {
    staticClass: "clear"
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 425:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-ctn"
  }, [_c('div', {
    staticClass: "background-shape",
    style: ({
      transform: "rotate3d(0,0,1," + this.transform.rotate + "deg) scale3d(" + this.transform.scale.x + ", " + this.transform.scale.y + ", 1) translate3d(" + this.transform.translate.x + ", " + this.transform.translate.y + ", 0)"
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.wave)
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 426:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 427:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ballsaal"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.headline)
    }
  }), _c('seperator'), _c('div', {
    staticClass: "body"
  }, [_vm._l((_vm.body), function(paragraph) {
    return _c('p', {
      domProps: {
        "innerHTML": _vm._s(paragraph)
      }
    })
  }), _c('a', {
    staticClass: "cta",
    attrs: {
      "href": "mailto:" + _vm.email
    }
  }, [_vm._v("Jetzt Anfragen")])], 2), _c('div', {
    staticClass: "clear"
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 428:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 429:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.headline)
    }
  }), _c('seperator'), _c('div', {
    staticClass: "body"
  }, [_vm._l((_vm.body), function(paragraph) {
    return _c('p', {
      domProps: {
        "innerHTML": _vm._s(paragraph)
      }
    })
  }), _c('router-link', {
    staticClass: "cta",
    attrs: {
      "to": "/kontakt"
    }
  }, [_vm._v("Kontakt")])], 2), _c('div', {
    staticClass: "clear"
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 430:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ctn"
    }
  }, [_c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.ready && !_vm.isMobileData),
      expression: "!ready && !isMobileData"
    }]
  }), _c('div', {
    staticClass: "left-bg"
  }), _c('div', {
    staticClass: "right-bg"
  }), _c('transition', {
    attrs: {
      "name": "background-shape",
      "css": false,
      "mode": "out-in",
      "appear": "appear"
    },
    on: {
      "enter": _vm.shapeEnter
    }
  }, [_c('route-background', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ready),
      expression: "ready"
    }],
    attrs: {
      "transform": _vm.currentBackground
    }
  })], 1), _c('site-nav'), _c('div', {
    staticClass: "wrap"
  }, [(_vm.ready) ? _c('site-header', {
    ref: "header",
    attrs: {
      "indicator": _vm.currentIndicator
    }
  }) : _vm._e(), (_vm.ready) ? _c('route-image', {
    attrs: {
      "image": _vm.currentImage
    }
  }) : _vm._e(), _c('div', {
    staticClass: "view-ctn"
  }, [(_vm.ready) ? _c('transition', {
    attrs: {
      "name": "page",
      "css": false,
      "mode": "out-in",
      "appear": "appear"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, [_c('router-view', {
    ref: "page",
    staticClass: "view"
  })], 1) : _vm._e(), _c('div', {
    staticClass: "clear"
  })], 1), _c('div', {
    staticClass: "clear"
  })], 1), _c('div', {
    staticClass: "clear"
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 431:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 432:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-ctn"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('svg', {
    staticClass: "shape-mask",
    attrs: {
      "viewBox": "0 0 400 500",
      "preserveAspectRatio": "none"
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "#FDFAF5"
    },
    attrs: {
      "d": "M400,460c0,0-17,40-106,40s-97-40-187-40S0,490,0,490V0c0,0,18,0,112,0s100,0,186,0s102,0,102,0V460z"
    }
  })]), _c('transition', {
    attrs: {
      "name": "shape-mask",
      "mode": "out-in",
      "css": false,
      "appear": "appear"
    },
    on: {
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, [_c('div', {
    key: _vm.image,
    staticClass: "img-wrap"
  }, [(_vm.image !== null) ? _c('img', {
    key: _vm.image,
    attrs: {
      "srcset": _vm.image.srcSet,
      "src": _vm.image.images ? _vm.image.images[2].path : _vm.image.src
    }
  }) : _vm._e(), (_vm.image !== null && _vm.image.center !== undefined) ? _c('gmap-map', {
    key: _vm.image,
    ref: "gmap",
    attrs: {
      "center": _vm.image.center,
      "zoom": 12,
      "options": _vm.image.options,
      "gestureHandling": "cooperative"
    }
  }, [_c('gmap-marker', {
    key: _vm.image,
    attrs: {
      "position": _vm.image.center,
      "icon": " ",
      "label": _vm.image.marker
    }
  })], 1) : _vm._e()], 1)])], 1), _c('div', {
    staticClass: "clear"
  })])
},staticRenderFns: []}

/***/ }),

/***/ 433:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kontakt"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.headline)
    }
  }), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "address"
  }, [_c('div', {
    staticClass: "contact-logo",
    domProps: {
      "innerHTML": _vm._s(_vm.body.address.logo)
    }
  }), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.body.address.street)
    }
  })]), _c('div', {
    staticClass: "contact"
  }, [_c('a', {
    attrs: {
      "href": "tel:" + _vm.body.contact.tel.raw
    }
  }, [_vm._v(_vm._s(_vm.body.contact.tel.nice))]), _c('br'), _c('a', {
    attrs: {
      "href": "mailto:" + _vm.body.contact.email
    }
  }, [_vm._v(_vm._s(_vm.body.contact.email))])]), _vm._m(0, false, false)]), _c('div', {
    staticClass: "clear"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "credits"
  }, [_c('p', {
    staticClass: "gold"
  }, [_vm._v("design & code by")]), _c('a', {
    attrs: {
      "href": "http://www.atelierkarasinski.com",
      "target": "blank"
    }
  }, [_vm._v("Atelier Karasinski")]), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.maxschulmeister.com",
      "target": "blank"
    }
  }, [_vm._v("Max Schulmeister")])])
}]}

/***/ }),

/***/ 434:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "blue"
  }), _c('div', {
    staticClass: "wave light-gold",
    domProps: {
      "innerHTML": _vm._s(_vm.wave)
    }
  }), _c('div', {
    staticClass: "wave gold",
    domProps: {
      "innerHTML": _vm._s(_vm.wave)
    }
  }), _c('div', {
    staticClass: "preload-images"
  }, _vm._l((_vm.images), function(image) {
    return _c('img', {
      attrs: {
        "srcset": image.srcSet,
        "src": image.images[2].path
      }
    })
  }))])
},staticRenderFns: []}

/***/ }),

/***/ 435:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "co-working"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.headline)
    }
  }), _c('div', {
    staticClass: "body plans"
  }, [_c('ul', _vm._l((_vm.plans), function(plan) {
    return _c('li', [_c('h3', [_vm._v(_vm._s(plan.title))]), _c('span', {
      staticClass: "price"
    }, [_vm._v(_vm._s(plan.price))]), _c('span', {
      staticClass: "span"
    }, [_vm._v(_vm._s(plan.span))])])
  })), _c('a', {
    staticClass: "cta",
    attrs: {
      "href": "mailto:" + _vm.email
    }
  }, [_vm._v("Jetzt Buchen")]), _c('p', {
    staticClass: "info"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.info)
    }
  })])]), _c('div', {
    staticClass: "clear"
  })])
},staticRenderFns: []}

/***/ }),

/***/ 436:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(381)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(423),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ })

},[312]);


// WEBPACK FOOTER //
// assets/js/app.8f271270d044d3d3a9d1.js